import { VehicleType } from './types';
import Lender from './types/Lender';
import * as Yup from 'yup';

//  APP CONFIGS  //
export const appDevConfig = {
	apiKey: 'AIzaSyBV8mADtM3r4SXEcB482mcSqYzTOaIGvTk',
	apiKeyBackend: 'AIzaSyAcUSpWKa_Ft4H1d9EM47P3PuWbNSnXT3s',
	authDomain: 'airdealer67669.firebaseapp.com',
	projectId: 'airdealer67669',
	storageBucket: 'airdealer67669.appspot.com',
	messagingSenderId: '484047561988',
	serviceAccountId: 'firebaseadminsdkdj19c@airdealer67669.iam.gserviceaccount.com',
};

export const appStagingConfig = {
	apiKey: 'AIzaSyCwjVnFf7VD1_tskB5GqToM43xD3wW3auA',
	apiKeyBackend: 'AIzaSyBhg2la37LEyByeFmE1Dgtzv5eqfk9gRmY',
	authDomain: 'edstaging.firebaseapp.com',
	projectId: 'edstaging',
	storageBucket: 'edstaging.appspot.com',
	messagingSenderId: '705378449535',
	serviceAccountId: 'firebaseadminsdk96vr8@edstaging.iam.gserviceaccount.com',
};

export const appJanusConfig = {
	apiKey: 'AIzaSyDDUmuZ2X_wvLB1j4WfVlMIu8BG9MWlKJE',
	apiKeyBackend: 'AIzaSyAypStZl3xCh1MfYSqStAZxvS4IyQ1AQHY',
	authDomain: 'janusproda3c47.firebaseapp.com',
	projectId: 'janusproda3c47',
	storageBucket: 'janusproda3c47.appspot.com',
	messagingSenderId: '233808214945',
	serviceAccountId: 'firebaseadminsdk3sur8@janusproda3c47.iam.gserviceaccount.com',
};

export const appE2etestoemConfig = {
	apiKey: 'AIzaSyC1ErKhx0c_yQ4_yaKsRvS2F4F_eLsH6xM',
	apiKeyBackend: 'AIzaSyDKdzuft9uZ7CsivQfyTWUoUBt7o2TXI1s',
	authDomain: 'e2etestoemprod.firebaseapp.com',
	projectId: 'e2etestoemprod',
	storageBucket: 'e2etestoemprod.appspot.com',
	messagingSenderId: '67737516161',
	serviceAccountId: 'firebaseadminsdkr4o7r@e2etestoemprod.iam.gserviceaccount.com',
};

// MAP OF THE FIREBASE PROJECT APP CONFIGS
export const appConfigMap = {
	// PRODUCTION CONFIGS
	e2etestoem: appE2etestoemConfig,
	janus: appJanusConfig,
	// DEVELOPMENT / STAGING CONFIGS
	staging: appStagingConfig,
	development: appDevConfig,
};

// CORS
// Cors options to only allow requests coming from these specific whitelisted domains
export const localWhitelist = [
	'http://localhost:3000',
	'http://localhost:3001',
	'http://localhost:3002',
	'http://localhost:8080',
	'https://edtesting6.myshopify.com',
	'https://ekhodealerdemostore1.myshopify.com',
	'https://ed-testing-dev.myshopify.com',
	'https://testingforekhodealer.blog',
];

// MAKE SURE THERE ARE NO TRAILING SLASHES ON THESE URLS
export const whitelistOEMSites = [
	'https://janusmotorcycles.com',
	'https://janus-testing.com',
	'https://mokeinternational.com',
	'https://moke1stg.wpenginepowered.com',
	'https://landmoto.io',
	'https://livebyland.myshopify.com',
	'https://land-moto-sandbox.myshopify.com',
	'https://www.thepickman.com',
	'https://maeving.com',
	'https://us.maeving.com',
	'https://maeving-usa.myshopify.com',
	'https://my.janus-testing.com',
	'https://starkfuture.com',
	'https://api.starkfuture.com',
	'https://pplusev.com',
	'https://619295-76.myshopify.com', // TODO use correct Shopify site
	'https://www.naxeontech.com',
	'https://infinitemachine.com', // TODO add more once we learn about their e-commerce setup
	'https://www.dustmoto.com',
	'https://bakcou.com',
	'https://bakcouebikes.myshopify.com',
	'https://www.niu.com',
	'https://www.global.niu.com',
	'https://www.shop.niu.com',
	'https://zeromotorcycles.com',
	'https://pavemotors.com',
	'https://www.livewire.com',
	'https://www.massimomotor.com',
	'https://sandboxacs.massimomotor.com',
	'https://ridebonnell.com',
	'https://chargedcycleworks.com',
	'https://www.royalenfield.com',
];

export const whitelistRetool = ['https://*.retool.com', 'https://admin.ekhodealer.com'];

export const whitelistZapier = ['https://zapier.com', 'https://hooks.zapier.com'];

// Env
export const ENV = {
	DEVELOPMENT: 'development',
	STAGING: 'staging',
	PRODUCTION: 'production',
	LOCAL: 'local',
};

// Max instances of an individual cloud function
export const MAX_INSTANCES = 1000;

// Default values for fees
// export const DEFAULT_ORDER_FEE = 500.0; // USD
// const DEFAULT_DELIVERY_FEE = 900.0; // USD
// const BASE_VITU_FEE = 160.0; // USD  165 estimate taken from VITU pricing sheet, mailing fee + vitu fee

export const ODOMETER_VALIDITY_VALS = ['Actual', 'ExceedsMechanicalLimits', 'NotActual'];
export const ODOMETER_VALIDITY_ENUM = {
	Actual: 'Actual',
	ExceedsMechanicalLimits: 'ExceedsMechanicalLimits',
	NotActual: 'NotActual',
};

// Financing
export const DECISION_LENDER_CREDIT_APP_SUBMIT_URL =
	'https://decisionlender.solutions/tci/api/portal/dl4/submit';

export const FREEDOMROAD_FINANCIAL_MINIMUM_LOAN_AMOUNT = 2500;
export const MAX_WEEKS_BEFORE_READY = 100;

export const FINANCING_STAGE_MAP = {
	financingChoicePage: 'Choosing Financing or Cash Option',
	financingInfoCollect: 'Filling out Credit App',
	confirmNativeFinancingDetailsPage: 'Confirming Credit App Details',
	creditAppRejected: 'Reviewing rejected credit app',
	creditAppMoreInfoNeeded: 'Reviewing cred app needs more info',
	nativeFinancingChoiceCollect: 'Configuring Loan to Apply For',
	nativeFinancingOfferDecisionCollect: 'Reviewing Offered Loan',
	nativeFinancingCompletedPage: 'Completed Financing Flow',
	nativeFinancingSignatures: 'Signing Financing Docs',
	financingDownPaymentInfoWrapper: 'Paying Financing Downpayment',
	laterCashPaymentCompletedPage: 'Opted to Pay in Cash Later',
	nativeFinancingInfoCollectionCompletedPage:
		'Completed Information Input, Waiting for Lender Decision',
	fullPaymentACHCompletedPage: 'Completed Full Cash Payment',
	downPaymentACHCompletedPage: 'Completed Additional Downpayment',
	bankManualVerificationPage: 'Manually Verifying Bank Account for ACH',
	'Has yet to review decision': 'Has yet to review decision',
};

export const NOTARY_FORM_TYPE = {
	NONE: 'NONE',
	NA: 'NA',
	ENOTARY: 'ENOTARY',
	PHYSICAL: 'PHYSICAL',
};

export const SIG_WORKFLOW_TYPE = {
	ESIGN: 'ESIGN',
	WET: 'WET',
};

export const SIG_FORM_TYPE_ENUM = {
	ESIGN: 'ESIGN',
	WET: 'WET',
	ROBOTIC: 'ROBOTIC',
};

export const NOTARY_WORKFLOW_TYPE = {
	ENOTARY: 'ENOTARY',
	PHYSICAL: 'PHYSICAL',
	NONE: 'NONE',
};

export const CHRIS_TESTING_EMAIL = 'chris@ekhodealer.com';

export const DOCUMENT_PACKET_TYPES = {
	BUYER_PACKET: 'BUYER_PACKET',
};

export const DOCUMENT_PACKET_NAMES = {
	BUYER_PACKET: 'buyerPacket.pdf',
	VOS_PACKET: 'vosPacket.pdf',
};

export const TAR_PREREQ_TO_FULFILL_ENUM = {
	NOT_REQUIRED: 'NOT_REQUIRED',
	TO_BE_DETERMINED: 'TO_BE_DETERMINED',
	REQUIRED: 'REQUIRED',
};

export const TRADE_IN_OPTIONS = {
	HAVE_TRADE_IN: 'HAVE_TRADE_IN',
	NO_TRADE_IN: 'NO_TRADE_IN',
};

export const AUTH_CLASSES = {
	BUYER: 'buyer',
	EKHO_ADMIN: 'ekhoAdmin',
	OEM_ADMIN: 'oemAdmin',
	SERVICES_PROVIDER: 'servicesProvider',
};

// Esigs
export const PANDADOC_MAX_RETRIES = 5;

export const ARBITRATION_FEE = 250;
export const CRA = 'Experian';

export const DUMMY_LENDER_INFO = {
	name: 'FRF',
	address: {
		street: 'PO BOX 18218',
		city: 'RENO',
		state: 'NV',
		zipCode: '89511',
		addressLineOne: 'PO BOX 18218',
		addressLineTwo: '',
		zip: '89511',
	},
	lenderStateId: '1234567890',
};

export const allSignaturePageNames = [
	'documentsSignatures',
	'nativeFinancingSignatures',
	'tarSignatures',
	'purchaseAgreementSignatures',
	'financingContractSignatures',
];

export const PAYMENT_RECEIPT_STATUS_TYPES = {
	CANCELED: 'canceled',
	FAILED: 'failed',
	PROCESSING: 'processing',
	SUCCEEDED: 'succeeded',
};

export const CLERQ_PAYMENT_STATUS_TYPES = {
	PROCESSING: 'PROCESSING',
	SUBMITTED: 'SUBMITTED',
	COMPLETED: 'COMPLETED',
	HOLD: 'HOLD',
	SETTLED: 'SETTLED',
	FAILED: 'FAILED',
};

export const PAYMENT_RECEIPT_DISPUTE_STATUS = {
	ONGOING: 'ONGOING',
	WON: 'WON',
	LOST: 'LOST',
};

export const DEFAULT_TRANSFER_ID = 'temp-transfer-id';
export const PRECHECKOUT_PAYMENT_ID = 'precheckout-payment-id';

export const CHECKOUT_CART_LINK_TYPES = {
	SINGLE_USE: 'SINGLE_USE',
	MULTI_USE: 'MULTI_USE',
};

export const REFUND_TYPES = {
	FULL_REFUND: 'FULL_REFUND',
	PARTIAL_REFUND: 'PARTIAL_REFUND',
};

export const PAYMENT_SCHEDULE_FREQUENCIES = {
	MONTHLY: 'monthly',
	QUARTERLY: 'quarterly',
	ANNUALLY: 'annually',
	BI_ANNUALLY: 'bi-annually',
};

export const REENGAGEMENT_MEDIUMS = {
	EMAIL: 'EMAIL',
	ALL: 'ALL',
};

export const PREQUAL_OUTCOMES = {
	NO_APPLICATION: 'NOT_STARTED',
	APPROVED: 'APPROVED',
	DENIED: 'DENIED',
};

export const DELIVERY_CHOICES = {
	SHIP: 'SHIP',
	PICK_UP: 'PICK_UP',
};

export const FALLBACK_PRODUCTION_TIME = 21;
export const FALLBACK_DELIVERY_TIME = 7;

export const signaturePageMetadata = {
	documentsSignatures: {
		documentName: 'Sale Documents',
		pageName: 'documentsSignatures',
		folderId: 'hwCrv8E7GT4WxUSadJ6UHT',
		templateId: '9afqZK8YXBsNtQTwrmAHTm',
		contentPlaceHolderBlockId: 'content_placeholder_1',
		instructionsPlaceHolderBlockId: 'instructions_placeholder_1',
	},
	nativeFinancingSignatures: {
		documentName: 'Financing Documents',
		pageName: 'nativeFinancingSignatures',
		folderId: 'ShPtbFVwJvM4Cc7rMKMYfX',
		templateId: '9afqZK8YXBsNtQTwrmAHTm',
		contentPlaceHolderBlockId: 'content_placeholder_1',
		instructionsPlaceHolderBlockId: 'instructions_placeholder_1',
	},
	tarSignatures: {
		documentName: 'Registration_Documents',
		pageName: 'tarSignatures',
		folderId: 'ShPtbFVwJvM4Cc7rMKMYfX', // TODO - change this to the correct folder ID
	},
	purchaseAgreementSignatures: {
		documentName: 'Purchase Agreement',
		pageName: 'purchaseAgreementSignatures',
		folderId: 'ShPtbFVwJvM4Cc7rMKMYfX', // TODO - change this to the correct folder ID
		templateId: '9afqZK8YXBsNtQTwrmAHTm',
		contentPlaceHolderBlockId: 'content_placeholder_1',
	},
	financingContractSignatures: {
		documentName: 'Financing Contract',
		pageName: 'financingContractSignatures',
		folderId: 'ShPtbFVwJvM4Cc7rMKMYfX', // TODO - change this to the correct folder ID
		templateId: '9afqZK8YXBsNtQTwrmAHTm',
		contentPlaceHolderBlockId: 'content_placeholder_1',
	},
	// NOTE: NOT A SIGNATURE PAGE
	ekhoWetSigDocs: {
		documentName: 'Ekho_Wet_Sig_TAR_documents',
		pageName: 'ekhoWetSigDocs',
		folderId: 'noCfNTdDdnk8ALcGA9X5V3',
		templateId: '9afqZK8YXBsNtQTwrmAHTm',
		contentPlaceHolderBlockId: 'content_placeholder_1',
		instructionsPlaceHolderBlockId: 'instructions_placeholder_1',
	},
	// NOTE: NOT A SIGNATURE PAGE -- this is a reference used to get the PandaDoc link for the documents the dealer must sign
	dealerTARDocs: {
		documentName: 'Dealer_TAR_documents',
		pageName: 'dealerTARDocs',
		folderId: 'ShPtbFVwJvM4Cc7rMKMYfX',
		templateId: '9afqZK8YXBsNtQTwrmAHTm',
		contentPlaceHolderBlockId: 'content_placeholder_1',
		instructionsPlaceHolderBlockId: 'instructions_placeholder_1',
	},
};

export const EKHO_SUPPORT_EMAIL = 'support@ekho.com';

// To do: update once we finish version two
export const BUYER_PORTAL_SECTIONS = {
	SIGN_OFF: 'signOff',
	FINANCING: 'financing',
	// DELIVERY_DETAILS: 'deliveryDetails',
	INSURANCE: 'insurance',
	REGISTRATION_AND_TITLING: 'registrationAndTitling',
	IDENTITY_VERIFICATION: 'identityVerification',
	DOCUMENTS_AND_SIGNATURES: 'documentsAndSignatures',
	PAYMENT: 'payment',
};

export const BUYER_PORTAL_STATUSES = {
	NOT_STARTED: 'NOT STARTED',
	NOT_APPLICABLE: 'N/A',
	BLOCKED: 'BLOCKED',
	IN_PROGRESS: 'IN PROGRESS',
	COMPLETED: 'COMPLETED',
	CANCELED: 'CANCELED',
	// T&R specific statuses
	AWAITING_IDENTITY_VERIFICATION: 'ID VERIFICATION',
	// Insurance specific statuses
	VALIDATING_INSURANCE: 'VALIDATING INSURANCE',
	SKIPPED_INSURANCE: 'SKIPPED INSURANCE',
	// Payment specific statuses
	BALANCE_DUE: 'BALANCE DUE',
	AWAITING_FUNDS: 'AWAITING FUNDS',
	FULLY_PAID: 'FULLY PAID',
	// Financing specific statuses
	SUBMITTING_APP: 'SUBMITTING APP',
	AWAITING_LENDER_DECISION: 'AWAITING LENDER DECISION',
	LOAN_OFFERED: 'LOAN OFFERED',
	LENDER_REJECTED_AND_CANCELED: 'CANCELED ORDER',
	LENDER_REJECTED_AND_PAYING_CASH: 'PAYING CASH',
	LENDER_REJECTED_AND_AWAITING_DECISION: 'AWAITING BUYER DECISION',
	BUYER_DECLINED_AND_CANCELED: 'CANCELED ORDER',
	BUYER_DECLINED_AND_PAYING_CASH: 'PAYING CASH',
	BUYER_DECLINED_AND_AWAITING_DECISION: 'AWAITING BUYER DECISION',
	AWAITING_DOWN_PAYMENT: 'AWAITING DOWN PAYMENT',
	// Used in both financing and paperwork sections
	AWAITING_SIGNATURES: 'AWAITING SIGNATURES',
};

export const FORM_THIRD_PARTY_SIGNER_ENUM = {
	VERIFIER: 'VERIFIER',
	DOCTOR: 'DOCTOR',
	MILITARY: 'MILITARY',
	NA: 'NA',
	NONE: 'NONE',
};

export const EKHO_WET_SIG_TAR_DOCS_KEY = 'ekhoWetSigDocs';
export const DEALER_TAR_DOCS_KEY = 'dealerTARDocs';

export const AVERAGE_LOAN_TERM = 48;

export const STATE_FORMS_SOURCE_TYPES = {
	VITU: 'VITU',
	CG: 'CG',
	BUYER: 'BUYER',
	EKHO: 'EKHO',
	OEM: 'OEM',
};

export const CRAMetadata = {
	Experian: {
		name: 'Experian',
		addressLineOne: 'TODO',
		city: 'TODO',
		state: 'TODO',
		zip: 'TODO',
		phone: 'TODO',
		website: 'TODO',
	},
};

export const TRANSACTION_STATUS_ENUM = {
	Started: 'Started',
	Draft: 'Draft',
	Completed: 'Completed',
	PreAuditInProgress: 'PreAuditInProgress',
	PreAuditErrorsFound: 'PreAuditErrorsFound',
	PreAuditCompleted: 'PreAuditCompleted',
	SentToService: 'SentToService',
	Received: 'Received',
	ErrorsFound: 'ErrorsFound',
	SentToState: 'SentToState',
	ReturnedFromState: 'ReturnedFromState',
	StateProcessed: 'StateProcessed',
	StateCompleted: 'StateCompleted',
	Inactive: 'Inactive',
	CompletedManually: 'CompletedManually',
	Canceled: 'Canceled',
	Failed: 'Failed',
	// custom internal statuses (i.e. not from VITU) are below
	CreationFailed: 'CreationFailed',
	CreationStarted: 'CreationStarted',
};

export const DELIVERY_METHOD_ENUM = {
	DrivenOffLot: 'DrivenOffLot',
	VehicleShipped: 'VehicleShipped',
};

export const TRANSACTION_STATUSES_AFTER_PREAUDIT_INITIATED = [
	TRANSACTION_STATUS_ENUM.PreAuditInProgress,
	TRANSACTION_STATUS_ENUM.PreAuditErrorsFound,
	TRANSACTION_STATUS_ENUM.PreAuditCompleted,
	TRANSACTION_STATUS_ENUM.SentToService,
	TRANSACTION_STATUS_ENUM.Received,
	TRANSACTION_STATUS_ENUM.SentToState,
	TRANSACTION_STATUS_ENUM.ReturnedFromState,
	TRANSACTION_STATUS_ENUM.StateProcessed,
	TRANSACTION_STATUS_ENUM.StateCompleted,
];

export const DOCUMENT_STEPS_ENUM = {
	FINALIZED_BUYER_PACKET: 'FINALIZED_BUYER_PACKET',
	BUYER_SENT_DOCUMENTS: 'BUYER_SENT_DOCUMENTS',
	OEM_SENT_DOCUMENTS: 'OEM_SENT_DOCUMENTS',
	LIENHOLDER_SENT_DOCUMENTS: 'LIENHOLDER_SENT_DOCUMENTS',
	SELLER_RECEIVED_ALL_DOCUMENTS: 'SELLER_RECEIVED_ALL_DOCUMENTS',
	SELLER_RECEIVED_BUYER_DOCUMENTS: 'SELLER_RECEIVED_BUYER_DOCUMENTS',
	SELLER_RECEIVED_OEM_DOCUMENTS: 'SELLER_RECEIVED_OEM_DOCUMENTS',
	SELLER_RECEIVED_LIENHOLDER_DOCUMENTS: 'SELLER_RECEIVED_LIENHOLDER_DOCUMENTS',
	SELLER_SENT_DOCUMENTS: 'SELLER_SENT_DOCUMENTS',
	SELLER_SENT_TEMP_TAG: 'SELLER_SENT_TEMP_TAG',
};

export const DEFAULT_PREORDER_LINK_NAME = 'Convert Preorder Link';

export const INSPECTION_TYPE_ENUM = {
	NONE: 'NONE',
	YES: 'YES',
	AFTER_DELIVERY: 'AFTER_DELIVERY',
};

export const FUNDING_PACKET_STATUS_ENUM = {
	UNABLE_TO_FUND: 'UNABLE_TO_FUND',
	SUBMITTED: 'SUBMITTED',
	FUNDED: 'FUNDED',
};

export const REQUESTED_TITLE_TYPE_ENUM = {
	ELECTRONIC_TITLE: 'ElectronicTitle',
	PAPER_TITLE: 'PaperTitle',
};

// Insurance
export const INSURANCE_VALID_DAYS_BUFFER = 15;
export const INSURANCE_EFFECTIVE_DAYS_BUFFER = 30;
export const MAX_VERIFICATION_ATTEMPTS = 3;
export const canopyConnectAddressTypes = {
	MAILING: 'MAILING',
	PHYSICAL: 'PHYSICAL',
	LIENHOLDER: 'LIENHOLDER',
	MORTGAGEE: 'MORTGAGEE',
};

export const VehicleCoverageCodes = {
	SINGLE_LIMIT_LIABILITY: 'SINGLE_LIMIT_LIABILITY',
	BODILY_INJURY_LIABILITY: 'BODILY_INJURY_LIABILITY',
	PROPERTY_DAMAGE_LIABILITY: 'PROPERTY_DAMAGE_LIABILITY',
	SUPPLEMENTAL_SPOUSAL_LIABILITY: 'SUPPLEMENTAL_SPOUSAL_LIABILITY',
	PERSONAL_INJURY_PROTECTION: 'PERSONAL_INJURY_PROTECTION',
	COMPREHENSIVE: 'COMPREHENSIVE',
	FULL_GLASS: 'FULL_GLASS',
	COLLISION_DEDUCTIBLE_WAIVER: 'COLLISION_DEDUCTIBLE_WAIVER',
	COLLISION: 'COLLISION',
	UNINSURED_MOTORISTS: 'UNINSURED_MOTORISTS',
	UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY',
	UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY',
	UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY:
		'UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY',
	UNDERINSURED_MOTORISTS: 'UNDERINSURED_MOTORISTS',
	UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY',
	UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY:
		'UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY',
	UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY:
		'UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY',
	UNINSURED_AND_UNDERINSURED_MOTORISTS: 'UNINSURED_AND_UNDERINSURED_MOTORISTS',
	UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY:
		'UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY',
	UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY:
		'UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY',
	UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY:
		'UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY',
	TOWING_AND_LABOR: 'TOWING_AND_LABOR',
	LOAN_OR_LEASE_ASSISTANCE: 'LOAN_OR_LEASE_ASSISTANCE',
	RIDESHARE_GAP_PROTECTION: 'RIDESHARE_GAP_PROTECTION',
	MEDICAL_PAYMENTS: 'MEDICAL_PAYMENTS',
	ADDITIONAL_LIVING_EXPENSE: 'ADDITIONAL_LIVING_EXPENSE',
	FAMILY_LIABILITY_PROTECTION: 'FAMILY_LIABILITY_PROTECTION',
	BUILDING_CODES: 'BUILDING_CODES',
	EMERGENCY_ROAD_SERVICE: 'EMERGENCY_ROAD_SERVICE',
	RENTAL_REIMBURSEMENT: 'RENTAL_REIMBURSEMENT',
	CAR_RENTAL_AND_TRAVEL_EXPENSES: 'CAR_RENTAL_AND_TRAVEL_EXPENSES',
	MECHANICAL_BREAKDOWN: 'MECHANICAL_BREAKDOWN',
	SUPPLEMENTAL_UNINSURED_AND_UNDERINSURED_MOTORISTS:
		'SUPPLEMENTAL_UNINSURED_AND_UNDERINSURED_MOTORISTS',
	EMERGENCY_EXPENSE: 'EMERGENCY_EXPENSE',
	REPLACEMENT_COST_PERSONAL_EFFECTS: 'REPLACEMENT_COST_PERSONAL_EFFECTS',
	VACATION_LIABILITY_COVERAGE: 'VACATION_LIABILITY_COVERAGE',
	RV_MEDICAL: 'RV_MEDICAL',
	EXTENDED_BENEFITS: 'EXTENDED_BENEFITS',
	WAGE_EARNER_DISABILITY_BENEFITS: 'WAGE_EARNER_DISABILITY_BENEFITS',
	ESSENTIAL_SERVICES_DISABILITY_BENEFITS: 'ESSENTIAL_SERVICES_DISABILITY_BENEFITS',
	DEATH_BENEFIT: 'DEATH_BENEFIT',
	CAR_REPLACEMENT_ASSISTANCE: 'CAR_REPLACEMENT_ASSISTANCE',
	FULL_TORT: 'FULL_TORT',
	LIMITED_TORT: 'LIMITED_TORT',
	COMBINED_SINGLE_LIMIT: 'COMBINED_SINGLE_LIMIT',
	LIABILITY_FOR_DEATH: 'LIABILITY_FOR_DEATH',
};

// This is a map of vehicle coverage code to any codes that are equivalent to it. It generally just covers the uninsured/underinsured motorist codes
export const EquivalentVehicleCoverageCodes = {
	[VehicleCoverageCodes.UNINSURED_MOTORISTS]: [
		`${VehicleCoverageCodes.UNDERINSURED_MOTORISTS}`,
		`${VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS}`,
	],
	[VehicleCoverageCodes.UNDERINSURED_MOTORISTS]: [
		`${VehicleCoverageCodes.UNINSURED_MOTORISTS}`,
		`${VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS}`,
	],
	[VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS]: [
		`${VehicleCoverageCodes.UNINSURED_MOTORISTS}`,
		`${VehicleCoverageCodes.UNDERINSURED_MOTORISTS}`,
	],
	// Uninsured Motorist Bodily Injury Liability
	[VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY]: [
		VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
		VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
	],

	// Underinsured Motorist Bodily Injury Liability
	[VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY]: [
		VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
		VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
	],

	// Uninsured and Underinsured Motorist Bodily Injury Liability
	[VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY]: [
		VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
		VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
	],

	// Uninsured Motorist Property Damage Liability
	[VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY]: [
		VehicleCoverageCodes.UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
		VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
	],

	// Underinsured Motorist Property Damage Liability
	[VehicleCoverageCodes.UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY]: [
		VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
		VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
	],

	// Uninsured and Underinsured Motorist Property Damage Liability
	[VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY]: [
		VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
		VehicleCoverageCodes.UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
	],

	// Uninsured Motorist Bodily Injury and Property Damage Liability
	[VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY]: [
		VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
		VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
	],

	// Underinsured Motorist Bodily Injury and Property Damage Liability
	[VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY]: [
		VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
		VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
	],

	// Uninsured and Underinsured Motorist Bodily Injury and Property Damage Liability
	[VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY]:
		[
			VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
			VehicleCoverageCodes.UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY,
		],
};

export const VehicleCoverageFriendlyNames = {
	SINGLE_LIMIT_LIABILITY: 'Single Limit Liability',
	BODILY_INJURY_LIABILITY: 'Bodily Injury Liability',
	PROPERTY_DAMAGE_LIABILITY: 'Property Damage Liability',
	SUPPLEMENTAL_SPOUSAL_LIABILITY: 'Supplemental Spousal Liability',
	PERSONAL_INJURY_PROTECTION: 'Personal Injury Protection',
	COMPREHENSIVE: 'Comprehensive',
	FULL_GLASS: 'Full Glass',
	COLLISION_DEDUCTIBLE_WAIVER: 'Collision Deductible Waiver',
	COLLISION: 'Collision',
	UNINSURED_MOTORISTS: 'Uninsured Motorists',
	UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'Uninsured Motorist Bodily Injury Liability',
	UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY: 'Uninsured Motorist Property Damage Liability',
	UNINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY:
		'Uninsured Motorist Bodily Injury & Property Damage Liability',
	UNDERINSURED_MOTORISTS: 'Underinsured Motorists',
	UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY: 'Underinsured Motorist Bodily Injury Liability',
	UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY:
		'Underinsured Motorist Property Damage Liability',
	UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY:
		'Underinsured Motorist Bodily Injury & Property Damage Liability',
	UNINSURED_AND_UNDERINSURED_MOTORISTS: 'Uninsured / Underinsured Motorists',
	UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_LIABILITY:
		'Uninsured / Underinsured Motorist Bodily Injury Liability',
	UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY:
		'Uninsured / Underinsured Motorist Property Damage Liability',
	UNINSURED_AND_UNDERINSURED_MOTORIST_BODILY_INJURY_AND_PROPERTY_DAMAGE_LIABILITY:
		'Uninsured / Underinsured Motorist Bodily Injury & Property Damage Liability',
	TOWING_AND_LABOR: 'Towing and Labor',
	LOAN_OR_LEASE_ASSISTANCE: 'Loan or Lease Assistance',
	RIDESHARE_GAP_PROTECTION: 'Rideshare Gap Protection',
	MEDICAL_PAYMENTS: 'Medical Payments',
	ADDITIONAL_LIVING_EXPENSE: 'Additional Living Expense',
	FAMILY_LIABILITY_PROTECTION: 'Family Liability Protection',
	BUILDING_CODES: 'Building Codes',
	EMERGENCY_ROAD_SERVICE: 'Emergency Road Service',
	RENTAL_REIMBURSEMENT: 'Rental Reimbursement',
	CAR_RENTAL_AND_TRAVEL_EXPENSES: 'Car Rental and Travel Expenses',
	MECHANICAL_BREAKDOWN: 'Mechanical Breakdown',
	SUPPLEMENTAL_UNINSURED_AND_UNDERINSURED_MOTORISTS:
		'Supplemental Uninsured / Underinsured Motorists',
	EMERGENCY_EXPENSE: 'Emergency Expense',
	REPLACEMENT_COST_PERSONAL_EFFECTS: 'Replacement Cost Personal Effects',
	VACATION_LIABILITY_COVERAGE: 'Vacation Liability Coverage',
	RV_MEDICAL: 'RV Medical',
	EXTENDED_BENEFITS: 'Extended Benefits',
	WAGE_EARNER_DISABILITY_BENEFITS: 'Wage Earner Disability Benefits',
	ESSENTIAL_SERVICES_DISABILITY_BENEFITS: 'Essential Services Disability Benefits',
	DEATH_BENEFIT: 'Death Benefit',
	CAR_REPLACEMENT_ASSISTANCE: 'Car Replacement Assistance',
	FULL_TORT: 'Full Tort',
	LIMITED_TORT: 'Limited Tort',
	COMBINED_SINGLE_LIMIT: 'Combined Single Limit',
	LIABILITY_FOR_DEATH: 'Liability for Death',
};

export const MAX_RETRIES = 5;

// NOTE: I've lower-cased all of these enum options. Make sure to toLowerCase() whatever you're checking it against.
export const ValidInsuranceTypesBasedOnVehicleType = {
	passenger: ['AUTO', 'CLASSIC_CAR', 'UMBRELLA', 'MOTORCYCLE'],
	motorcycle: ['AUTO', 'MOTORCYCLE', 'UMBRELLA'],
	truck: ['UMBRELLA', 'AUTO'],
	commercial: ['COMMERCIAL_AUTO', 'COMMERCIAL_UMBRELLA'],
	trailer: ['AUTO', 'TRAILER', 'RECREATIONAL_VEHICLE'],
	moped: ['OFFROAD_VEHICLE', 'AUTO', 'MOTORCYCLE'],
	ohv: ['OFFROAD_VEHICLE', 'RECREATIONAL_VEHICLE', 'SNOWMOBILE', 'MOTORCYCLE'],
	vessel: ['BOAT'],
};

export const DocumentTypesToDownload = [
	// 'INSURANCE_APPLICATION',
	'INSURANCE_BINDER',
	'DECLARATIONS',
	// 'ENDORSEMENT',
	'INSURANCE_ID_CARD',
	'VERIFICATION_OF_INSURANCE',
];

export const insuranceMinimumLevelTypesEnum = {
	PER_PERSON_LIMIT: 'per_person_limit_cents',
	PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT: 'per_incident_limit_cents',
	DEDUCTIBLE: 'deductible_cents',
	ACTUAL_CASH_VALUE: 'actual_cash_value',
	PER_DAY_LIMIT: 'per_day_limit_cents', // comes with max_days by default?
};

// Make sure this returns an array in the same form as what we list in minimumLevels within the stateData objects in stateData.js
// eslint-disable-next-line no-unused-vars
export const insuranceMinimumLevels = (lender: Lender, vehicleTotalPrice: number) => [
	// Canopy Connect doesn't widely support actual_cash_value just yet. In the actual checking of policies, we can safely assume for now that a policy will meet this threshold
	{
		code: VehicleCoverageCodes.COLLISION,
		name: VehicleCoverageFriendlyNames.COLLISION,
		type: insuranceMinimumLevelTypesEnum.ACTUAL_CASH_VALUE,
		amount: vehicleTotalPrice,
	},
	{
		code: VehicleCoverageCodes.COLLISION,
		name: VehicleCoverageFriendlyNames.COLLISION,
		type: insuranceMinimumLevelTypesEnum.DEDUCTIBLE,
		amount: lender.maxDeductible,
	},
	{
		code: VehicleCoverageCodes.COMPREHENSIVE,
		name: VehicleCoverageFriendlyNames.COMPREHENSIVE,
		type: insuranceMinimumLevelTypesEnum.ACTUAL_CASH_VALUE,
		amount: vehicleTotalPrice,
	},
	{
		code: VehicleCoverageCodes.COMPREHENSIVE,
		name: VehicleCoverageFriendlyNames.COMPREHENSIVE,
		type: insuranceMinimumLevelTypesEnum.DEDUCTIBLE,
		amount: lender.maxDeductible,
	},
];

export const DocumentTypesToDownloadMap = {
	// INSURANCE_APPLICATION: 'INSURANCE_APPLICATION',
	INSURANCE_BINDER: 'INSURANCE_BINDER',
	DECLARATIONS: 'DECLARATIONS',
	// ENDORSEMENT: 'ENDORSEMENT',
	INSURANCE_ID_CARD: 'INSURANCE_ID_CARD',
	VERIFICATION_OF_INSURANCE: 'VERIFICATION_OF_INSURANCE',
};

export const RIC_NOTIFICATION_EXPIRATION_HOURS = 23;

// Inspection

export const inspectionTypesEnum = {
	YES: 'YES',
	NONE: 'NONE',
};

export const OWNER_TYPES = {
	INDIVIDUAL: 'Individual',
	BUSINESS: 'Business',
};

// Payment

export const VehiclePaymentStatusOptions = {
	NO_PAYMENTS: 'NO_PAYMENTS',
	RESERVATION_PAID: 'RESERVATION_PAID',
	RESERVATION_INITIATED: 'RESERVATION_INITIATED',
	FINANCING_GUARANTEED: 'FINANCING_GUARANTEED',
	FULLY_PAID: 'FULLY_PAID',
	DOWNPAYMENT_PAID: 'DOWNPAYMENT_PAID',
	LOST_DISPUTE: 'LOST_DISPUTE',
};

export const TYPE_OF_ORDER_ENUM = {
	PREORDER: 'preorder',
	BUILD_TO_ORDER: 'buildToOrder',
	INVENTORY_ORDER: 'inventoryOrder',
};

// Should live in the const file
export const STRIPE_METADATA_FIELD_TYPES = {
	processing_fee_inc: Boolean,
	env: String,
	payment_type: String,
	oem_key: String,
	purchased_vehicle_id: String,
	order_id: String,
	buyer_id: String,
	buyer_email: String,
	buyer_name: String,
	additional_dues_id: String,
	processing_fee_inc_amount: Number, // STORED IN DOLLARS AND CENTS!
	oem_id: String,
	eng: String,
};

export const PAYMENT_PLATFORM_TYPES = {
	BREX: 'brex',
	STRIPE: 'stripe',
	CLERQ: 'clerq',
};

export const PAYMENT_SOURCES = {
	BUYER: 'buyer',
	LENDER: 'lender',
};

export const PAYMENT_METHOD_TYPES = {
	CARD: 'card',
	US_BANK_ACCOUNT: 'us_bank_account', // SAME AS ACH
	WIRE: 'wire',
	KLARNA: 'klarna',
};

export const BREX_TRANSFER_DIRECTION = {
	INCOMING: 'INCOMING',
	OUTGOING: 'OUTGOING',
};

export const PAYMENT_INTENT_STATUS_TYPES = {
	// STRIPE PAYMENT INTENT STATUSES
	// https://stripe.com/docs/payments/payment-intents/status
	SUCCEEDED: 'succeeded',
	REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
	REQUIRES_CONFIRMATION: 'requires_confirmation',
	PROCESSING: 'processing',
	CANCELED: 'canceled',
	REQUIRES_CAPTURE: 'requires_capture',
	REQUIRES_ACTION: 'requires_action',
};

export const CLERQ_AUTHORIZATION_CODES = {
	AUTHORIZED: 'AUTHORIZED',
	AUTHORIZED_WITH_HOLD: 'AUTHORIZED_WITH_HOLD',
	DECLINED: 'DECLINED',
};

export const CHECKOUT_SECTIONS = {
	CONFIGURATOR: 'CONFIGURATOR', // NOT USED YET => CONFIGURATOR IS CURRENTLY IN ORDER_DETAILS SECTION
	ORDER_DETAILS: 'ORDER_DETAILS',
	CREDIT_APP: 'CREDIT_APP',
};

export const LENDER_DECISION_REASONS = {
	CREDIT_APP_CRITERIA_MISS: 'CREDIT_APP_CRITERIA_MISS',
	AUTO_REJECTED: 'AUTO_REJECTED',
	REVIEWED_AND_REJECTED: 'REVIEWED_AND_REJECTED',
	MANUALLY_REJECTED: 'MANUALLY_MARKED_REJECTED',
	WITHDRAWN: 'WITHDRAWN',
	AUTO_ACCEPTED: 'AUTO_ACCEPTED',
	REVIEWED_AND_ACCEPTED: 'REVIEWED_AND_ACCEPTED',
	MANUALLY_ACCEPTED: 'MANUALLY_MARKED_ACCEPTED',
	STIPS_CLEARED_AND_ACCEPTED: 'STIPS_CLEARED_AND_ACCEPTED',
};

export const CREDIT_APP_REJECTION_REASONS = {
	IRREGULAR_HIT: 'IRREGULAR_HIT',
	NO_HIT: 'NO_HIT',
	INVALID_SSN: 'INVALID_SSN',
	LTV_THRESHOLD: 'LTV_THRESHOLD',
	FICO_SCORE_BAND: 'FICO_SCORE_BAND',
	FICO_SCORE_UNAVAILABLE: 'FICO_SCORE_UNAVAILABLE',
};

export const INTERNAL_CREDIT_FILE_HIT_TYPES = {
	NO_HIT: 'NO_HIT',
	IRREGULAR_HIT: 'IRREGULAR_HIT',
	REGULAR_HIT: 'REGULAR_HIT',
};

export const MAILGUN_API_USERNAME = 'api';

export const PLACED_ORDER_EVENT_CODES = {
	CREATED: 'CREATED',
	UPDATED: 'UPDATED',
};

export const PURCHASED_VEHICLE_EVENT_CODES = {
	CREATED: 'CREATED',
	UPDATED: 'UPDATED',
};

// -- Don't change these two values unless you talk with Chris -- //
export const RIC_VALID_LENGTH = 35; // in days - assumes 45 days until first payment!
export const DEFAULT_DAYS_UNTIL_FIRST_PAYMENT = 45;

export const BREX_LLC_ACCOUNT_ID = 'dpacc_clgfzgo9x00aq0pib3weo0fuu';

export const CG_BREXVENDOR_DETAILS = {
	VENDOR_ID: 'pdcont_clxd9wg0a03jd0k8s4sw07gsf',
	PAYMENT_INSTRUMENT_ID: 'pdinstl_clxd9wgau21rs0g8amhf1gt6i',
};

// Position enum for relocation and modal queue objects
export const QUEUE_POSITION_ENUM = {
	FRONT: 'FRONT',
	BACK: 'BACK',
};

// Action enum for relocation and modal queue objects
export const QUEUE_OBJECT_ACTION_ENUM = {
	CREATE: 'CREATE',
	DELETE: 'DELETE',
};

// TAR

export const DUMMY_TAR_INSURANCE_DATA = {
	companyName: 'Dummy Insurance Company',
	policyNumber: '123456789',
	insuranceCode: '12345',
	agentBrokerName: 'Dummy Agent',
};

export const TAX_CONSTS = {
	COsellerSalesTaxAccountNumber: '', // TODO replace with correct number
	COsellerCitySalesTaxAccountNumber: '', // TODO replace with correct number
};

export const RegistrationConstants = {
	saleType: 'Purchase',
	vehicleSoldAs: 'New',
};

export const HTTP_FIREBASE_ERROR_NAMES = {
	CANCELLED: 'cancelled',
	UNKNOWN: 'unknown',
	INVALID_ARGUMENT: 'invalid-argument',
	DEADLINE_EXCEEDED: 'deadline-exceeded',
	NOT_FOUND: 'not-found',
	ALREADY_EXISTS: 'already-exists',
	PERMISSION_DENIED: 'permission-denied',
	RESOURCE_EXHAUSTED: 'resource-exhausted',
	FAILED_PRECONDITION: 'failed-precondition',
	ABORTED: 'aborted',
	OUT_OF_RANGE: 'out-of-range',
	UNIMPLEMENTED: 'unimplemented',
	INTERNAL: 'internal',
	UNAVAILABLE: 'unavailable',
	DATA_LOSS: 'data-loss',
	UNAUTHENTICATED: 'unauthenticated',
};

// =============== TAR ENUMS ================ //

export const AK_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRAILER: 'Trailer',
	TRUCKPICKUP: 'TruckPickup',
	ATV: 'ATV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
	MOTORHOME: 'Motorhome',
};

export const DC_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	COMMERCIAL: 'Commercial',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRAILER: 'Trailer',
	AUTOCYCLE: 'Autocycle',
	LOW_SPEED: 'LowSpeed',
	MOTORHOME: 'Motorhome',
};

export const RI_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	MOTORSCOOTER: 'Motorscooter',
	TRAILER: 'Trailer',
	TRUCK: 'Truck',
	MOTORHOME: 'Motorhome',
};

export const NH_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	TRAILBIKE: 'Trailbike',
	OHV: 'OHV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const ME_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	MOTORHOME: 'Motorhome',
	MOTORSCOOTER: 'Motorscooter',
	ATV: 'ATV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const WV_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	TRUCK: 'Truck',
	ATV: 'ATV',
	UTV: 'UTV',
	GOLFCART: 'Golfcart',
	LOW_SPEED: 'LowSpeed',
	VESSEL: 'Vessel',
};

export const VT_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRAILER: 'Trailer',
	TRUCK: 'Truck',
	ATV: 'ATV',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const SD_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	LOW_SPEED: 'LowSpeed',
	MOTORHOME: 'Motorhome',
	OHV: 'OHV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const NE_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	MINIBIKE: 'Minibike',
	MOTORSCOOTER: 'Motorscooter',
	TRUCK: 'Truck',
	MINI_TRUCK: 'MiniTruck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	UTV: 'UTV',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const AL_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	PICKUP: 'Pickup',
	SUV: 'SUV',
	ATV: 'ATV',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	UTV: 'UTV',
	VAN: 'Van',
	VESSEL: 'Vessel',
};

export const IA_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	MOPED: 'Moped',
	ATV: 'ATV',
	LOW_SPEED: 'Lowspeed',
	OHV: 'OHV',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	Snowmobile: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const KY_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	ATV: 'ATV',
	MOTORHOME: 'Motorhome',
	LOW_SPEED: 'LowSpeed',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const MA_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	COMMERCIAL: 'Commercial',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	AUTOHOME: 'AutoHome',
	TAXI: 'Taxi',
	ATV: 'ATV',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const CT_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	ATV: 'ATV',
	SNOWMOBILE: 'Snowmobile',
	CARGO_SHUTTLE_VAN: 'CargoShuttleVan',
	MOTORHOME: 'Motorhome',
	VESSEL: 'Vessel',
};

export const NJ_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	PICKUP: 'Pickup',
	TRAILER: 'Trailer',
	ATV: 'ATV',
	AUTOCYCLE: 'Autocycle',
	FARM_TRUCK: 'FarmTruck',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const MD_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	UTV: 'UTV',
	SNOWMOBILE: 'Snowmobile',
	AUTOCYCLE: 'Autocycle',
	LIMITED_SPEED_VEHICLE: 'LimitedSpeedVehicle',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	MOTORSCOOTER: 'Motorscooter',
	VESSEL: 'Vessel',
};

export const UT_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	ATV: 'ATV',
	AUTOCYCLE: 'Autocycle',
	OHV: 'OHV',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	VESSEL: 'Vessel',
};

export const IL_VEHICLE_TYPE_ENUM = {
	// Passenger, Motorcycle, Truck, Trailer, Motorhome, ATV, LowSpeedVehicle, Snowmobile, Van, Vessel
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	SNOWMOBILE: 'Snowmobile',
	VAN: 'Van',
	VESSEL: 'Vessel',
};

export const MS_VEHICLE_TYPE_ENUM = {
	// Passenger, Motorcycle, Moped, Truck, Trailer, Motorhome, Vessel
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	VESSEL: 'Vessel',
};

export const AR_VEHICLE_TYPE_ENUM = {
	// Passenger, Motorcycle, Trailer, Motorhome, Truck, ATV, LowSpeed, Vessel
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	TRUCK: 'Truck',
	ATV: 'ATV',
	LOW_SPEED: 'LowSpeed',
	VESSEL: 'Vessel',
};

export const CA_VEHICLE_TYPE_ENUM = {
	// Passenger, Motorcycle, Moped, Truck, Commercial, Trailer, Motorhome, OHV, Vessel
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	COMMERCIAL: 'Commercial',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	OHV: 'OHV',
	VESSEL: 'Vessel',
};

export const TX_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRAILER: 'Trailer',
	TRUCK: 'Truck',
	MOTORHOME: 'Motorhome',
	PASSENGER_TRUCK: 'PassengerTruck',
};

export const WI_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	TRUCK: 'Truck',
	FARM_TRUCK: 'FarmTruck',
	TRAILER: 'Trailer',
	MOTORHOME: 'MotorHome',
	ATV: 'ATV',
	AUTOCYCLE: 'Autocycle',
	SNOWMOBILE: 'Snowmobile',
	UTV: 'UTV',
	VESSEL: 'Vessel',
};

export const OR_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	ATV: 'ATV',
	GOLF_CART: 'GolfCart',
	LOW_SPEED: 'LowSpeed',
	MEDIUM_SPEED: 'MediumSpeed',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const MN_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	FARM_TRUCK: 'FarmTruck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	OHV: 'OHV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const MO_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	ATV: 'ATV',
	AUTOCYCLE: 'Autocycle',
	LOW_SPEED: 'LowSpeedVehicle',
	MOTORHOME: 'Motorhome',
	TRICYCLE: 'Tricycle',
	TRAILER: 'Trailer',
	VESSEL: 'Vessel',
};

export const OK_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	TRUCK: 'Truck',
	MOPED: 'Moped',
};

export const MT_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	SUV: 'SUV',
	CARGO_SHUTTLE_VAN: 'CargoShuttleVan',
	ATV: 'ATV',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const LA_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRAILER: 'Trailer',
	TRUCK: 'Truck',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	UTV: 'UTV',
	GOLF_CART: 'GolfCart',
	LOW_SPEED: 'LowSpeed',
	VESSEL: 'Vessel',
};

export const NM_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const MI_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	COMMERCIAL_TRUCK: 'CommercialTruck',
	ATV: 'ATV',
	FARM_TRUCK: 'FarmTruck',
	MOTORHOME: 'Motorhome',
	OHV: 'OHV',
	SNOWMOBILE: 'Snowmobile',
	TRUCK_TRACTOR: 'TruckTractor',
	CARGO_SHUTTLE_VAN: 'CargoShuttleVan',
	VESSEL: 'Vessel',
};
export const CO_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	FARM_TRUCK: 'FarmTruck',
	FARM_TRACTOR: 'FarmTractor',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	OHV: 'OHV',
	VESSEL: 'Vessel',
};

export const FL_VEHICLE_TYPE_ENUM = {
	AUTO: 'Auto',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	OHV: 'OHV',
	ATV: 'ATV',
	GOLFCART: 'Golfcart',
	VESSEL: 'Vessel',
};

export const NY_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	PICKUP: 'Pickup',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	OHV: 'OHV',
	ATV: 'ATV',
	VESSEL: 'Vessel',
};

export const KS_VEHICLE_TYPE_ENUM = {
	// Passenger, Motorcycle, Moped, Truck, MiniTruck, Trailer, Motorhome, ATV, OHV, ORV, Vessel
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	MINI_TRUCK: 'MiniTruck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	OHV: 'OHV',
	ORV: 'ORV',
	VESSEL: 'Vessel',
};

export const TN_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	GOLF_CART: 'GolfCart',
	LOW_SPEED: 'LowSpeed',
	MEDIUM_SPEED: 'MediumSpeed',
	OHV: 'OHV',
	SNOWMOBILE: 'Snowmobile',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	VESSEL: 'Vessel',
};

export const AZ_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	ATV: 'ATV',
	GOLF_CART: 'GolfCart',
	MOTORHOME: 'Motorhome',
	OHV: 'OHV',
	TRAILER: 'Trailer',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const GA_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	SNOWMOBILE: 'Snowmobile',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
};

export const SC_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	ATV: 'ATV',
	GOLF_CART: 'Golfcart',
	SNOWMOBILE: 'Snowmobile',
	LOW_SPEED: 'LowSpeed',
	SAILBOAT: 'Sailboat',
	VESSEL: 'Vessel',
};

export const NC_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	FARMTRUCK: 'FarmTruck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	LOW_SPEED: 'LowSpeed',
	VESSEL: 'Vessel',
};

export const OH_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	FARM_TRUCK: 'FarmTruck',
	FARM_TRACTOR: 'FarmTractor',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
	MINI_TRUCK: 'MiniTruck',
	GOLFCART: 'Golfcart',
	UTV: 'UTV',
	MOTORSCOOTER: 'Motorscooter',
	ATV: 'ATV',
};

export const VA_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	PICKUP_TRUCK: 'PickupTruck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ATV: 'ATV',
	AUTOCYCLE: 'Autocycle',
	VESSEL: 'Vessel',
};

export const PA_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	LOW_SPEED: 'LowSpeed',
	ATV: 'ATV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const WA_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	GOLFCART: 'GolfCart',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	OHV: 'OHV',
	SNOWBIKE: 'SnowBike',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const NV_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	ATV: 'ATV',
	GOLFCART: 'GolfCart',
	SNOWMOBILE: 'Snowmobile',
	OHV: 'OHV',
	DUNEBUGGY: 'DuneBuggy',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
};

export const ID_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	MOPED: 'Moped',
	MOTORHOME: 'Motorhome',
	TRAILER: 'Trailer',
	AUTOCYCLE: 'Autocycle',
	ATV: 'ATV',
	UTV: 'UTV',
	SNOWMOBILE: 'Snowmobile',
	OHV: 'OHV',
	VESSEL: 'Vessel',
};

export const IN_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRUCK: 'Truck',
	TRACTOR: 'Tractor',
	MINITRUCK: 'Minitruck',
	MOPED: 'Moped',
	MOTORDRIVENCYCLE: 'MotorDrivenCycle',
	MOTORSCOOTER: 'Motorscooter',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	ORV: 'ORV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const ND_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	MOPED: 'Moped',
	TRUCK: 'Truck',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	LOW_SPEED_VEHICLE: 'LowSpeedVehicle',
	OHV: 'OHV',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const WY_VEHICLE_TYPE_ENUM = {
	PASSENGER: 'Passenger',
	MOTORCYCLE: 'Motorcycle',
	TRAILER: 'Trailer',
	MOTORHOME: 'Motorhome',
	TRUCK: 'Truck',
	ATV: 'ATV',
	GOLF_CART: 'Golfcart',
	SNOWMOBILE: 'Snowmobile',
	VESSEL: 'Vessel',
};

export const ND_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	PLUG_IN_HYBRID: 'PlugInHybrid',
	OTHER: 'Other',
};

export const DC_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	OTHER: 'Other',
};

export const RI_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	FLEX: 'Flex',
	CNG: 'CNG',
	PROPANE: 'Propane',
	HYBRID: 'Hybrid',
};

export const NH_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	PLUG_IN_HYBRID: 'PlugInHybrid',
	OTHER: 'Other',
};

export const ME_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	FLEX: 'Flex',
	CNG: 'CNG',
	PROPANE: 'Propane',
	NONE: 'None',
};

export const WV_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	BATTERY_ELECTRIC_VEHICLE: 'BatteryElectricVehicle',
	PLUG_IN_HYBRID_ELECTRIC_VEHICLE: 'PlugInHybridElectricVehicle',
	FUEL_CELL_VEHICLE: 'FuelCellVehicle',
	OTHER: 'Other',
	HYBRID: 'Hybrid',
};

export const VT_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	PROPANE: 'Propane',
	OTHER: 'Other',
};

export const SD_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	FLEX: 'Flex',
	CNG: 'CNG',
	PROPANE: 'Propane',
	NONE: 'None',
};

export const NE_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
};

export const IA_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	OTHER: 'Other',
};

export const AL_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	OTHER: 'Other',
};

export const KY_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
};

export const MA_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	PROPANE: 'Propane',
	OTHER: 'Other',
};

export const CT_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
};

export const NJ_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	NATURAL_GAS_POWERED: 'NaturalGasPowered',
	PLUG_IN: 'PlugIn',
	OTHER: 'Other',
};

// VITU has no map for WI so we are creating our own as we learn about different fuel types from doing sampel T&R transactions
export const WI_FUEL_TYPE_ENUM = {
	// Gas, Electric
	GAS: 'Gas',
	ELECTRIC: 'Electric',
};

export const WY_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	OTHER: 'Other',
};

export const CA_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	NATURAL_GAS_POWERED: 'NaturalGasPowered',
	ELECTRIC: 'Electric',
	FLEX_FUEL: 'FlexFuel',
	HYBRID_DIESEL_ELECTRIC: 'HybridDieselElectric',
	HYBRID_GASOLINE_ELECTRIC: 'HybridGasolineElectric',
	HYDROGEN_FUEL_CELL: 'HydrogenFuelCell',
	BUTANE: 'Butane',
	METHANOL: 'Methanol',
	PROPANE: 'Propane',
};

export const KS_FUEL_TYPE_ENUM = {
	// Gasoline, Diesel, Electric, HybridElectricPlugIn, Other
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID_ELECTRIC_PLUG_IN: 'HybridElectricPlugIn',
	OTHER: 'Other',
};

export const MS_FUEL_TYPE_ENUM = {
	// Gasoline, Diesel, Electric, Hybrid, Other
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	OTHER: 'Other',
};

export const AR_FUEL_TYPE_ENUM = {
	// Gas, Diesel, Hybrid, Electric, HydrogenatedOil, FlexFuel
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	HYDROGENATED_OIL: 'HydrogenatedOil',
	FLEX_FUEL: 'FlexFuel',
};

export const TX_FUEL_TYPE_ENUM = {
	// Gas, NaturalGas, Diesel, Hybrid, FullHybrid, Electric, Hydrogen, Other
	GAS: 'Gas',
	NATURAL_GAS: 'NaturalGas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	FULL_HYBRID: 'FullHybrid',
	ELECTRIC: 'Electric',
	HYDROGEN: 'Hydrogen',
	OTHER: 'Other',
};

export const OR_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	FLEX_FUEL: 'FlexFuel',
	PLUG_IN_HYBRID: 'PlugInHybrid',
	OTHER: 'Other',
};

export const MN_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID_DIESEL: 'HybridDiesel',
	HYBRID_GASOLINE: 'HybridGasoline',
	ELECTRIC: 'Electric',
	OTHER: 'Other',
	UNKNOWN: 'Unknown',
};

export const OK_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	PLUG_IN_HYBRID: 'PlugInHybrid',
	HYBRID: 'Hybrid',
	OTHER: 'Other',
};

export const MT_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	LIQUID_PETROLEUM: 'LiquidPetroleum',
	PROPANE: 'Propane',
	OTHER: 'Other',
};

export const MO_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
	LIQUID_NATURAL_GAS: 'LiquidNaturalGas',
	HYDROGEN: 'Hydrogen',
	PROPANE: 'Propane',
	SOLAR: 'Solar',
	PLUG_IN_HYBRID: 'PlugInHybrid',
	OTHER: 'Other',
};

export const IL_FUEL_TYPE_ENUM = {
	// Gas, Diesel, Hybrid, Electric
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
};

export const WA_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	PLUG_IN: 'PlugIn',
	ELECTRIC: 'Electric',
	OTHER: 'Other',
};

export const NM_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
};

export const MI_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	OTHER: 'Other',
};

export const OH_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	HYDROGEN: 'Hybrid',
	ELECTRIC_OR_HYBRID: 'ElectricOrPlugInHybrid',
};

export const CO_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	PLUG_IN: 'PlugIn',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	FLEX_FUEL: 'FlexFuel',
	OTHER: 'Other',
};

export const FL_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
	LIQUIFIED_NATURAL_GAS: 'LiquifiedNaturalGas',
	LIQUIFIED_PETROLEUM_GAS: 'LiquifiedPetroleumGas',
	COMBINATION_CLEAN_FUEL: 'CombinationCleanFuel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	HYDROGEN: 'Hydrogen',
	METHANE: 'Methane',
	SOLAR_POWERED: 'SolarPowered',
};

export const NY_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	FLEX: 'Flex',
	CNG: 'CNG',
	PROPANE: 'Propane',
	NONE: 'None',
};

export const AZ_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	HYDROGEN: 'Hydrogen',
	SOLAR: 'Solar',
	OTHER: 'Other',
};

export const GA_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	HYDROGEN: 'Hydrogen',
	SOLAR: 'Solar',
	OTHER: 'Other',
	FLEX_FUEL: 'FlexFuel',
	COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
	LIQUIFIED_NATURAL_GAS: 'LiquefiedNaturalGas',
	PROPANE: 'Propane',
};

export const VA_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	LIQUIFIED_NATURAL_GAS: 'LiquifiedNaturalGas',
	OTHER: 'Other',
};

export const PA_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	PROPANE: 'Propane',
	HYBRID: 'Hybrid',
	CONVERTIBLE: 'Convertible',
	FLEXIBLE: 'Flexible',
	ETHANOL: 'Ethanol',
	COMPRESSED_NATURAL_GAS: 'CompressedNaturalGas',
	LIQUID_NATURAL_GAS: 'LiquidNaturalGas',
	METHANOL: 'Methanol',
	HYDROGEN_FUEL_CELL: 'HydrogenFuelCell',
	OTHER: 'Other',
	UNKNOWN: 'Unknown',
};

export const NV_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	OTHER: 'Other',
};

export const UT_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID_ELECTRIC: 'HybridElectric',
	PLUG_IN_HYBRID_ELECTRIC: 'PlugInHybridElectric',
	OTHER: 'Other',
};

export const MD_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	ELECTRIC: 'Electric',
	HYBRID: 'Hybrid',
	FUEL_CELL: 'FuelCell',
};

export const IN_FUEL_TYPE_ENUM = {
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	CNG: 'CNG',
	PROPANE: 'Propane',
};

export const DEFAULT_FUEL_TYPE_ENUM = {
	// states using this enum [TN, SC, NC]
	GAS: 'Gas',
	DIESEL: 'Diesel',
	HYBRID: 'Hybrid',
	ELECTRIC: 'Electric',
	OTHER: 'Other',
};

export const INTERNAL_COLOR_ENUM = {
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	DARKBLUE: 'DarkBlue',
	LIGHTBLUE: 'LightBlue',
	BROWN: 'Brown',
	BRONZE: 'Bronze',
	CHROMESTEEL: 'ChromeSteel',
	COPPER: 'Copper',
	CREAMIVORY: 'CreamIvory',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	DARKGREEN: 'DarkGreen',
	LIGHTGREEN: 'LightGreen',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROONBURGUNDY: 'MaroonBurgundy',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVERALUMINUM: 'SilverAluminum',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};

export const MA_COLOR_ENUM = {
	BLACK: 'Black',
	BLUE: 'Blue',
	BROWN: 'Brown',
	RED: 'Red',
	YELLOW: 'Yellow',
	GREEN: 'Green',
	WHITE: 'White',
	GRAY: 'Gray',
	PURPLE: 'Purple',
	ORANGE: 'Orange',
	SILVER: 'Silver',
	GOLD: 'Gold',
};

export const ME_COLOR_ENUM = {
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	BLUEDARK: 'BlueDark',
	BLUELIGHT: 'BlueLight',
	BROWN: 'Brown',
	BRONZE: 'Bronze',
	CHROMESTEEL: 'ChromeSteel',
	COPPER: 'Copper',
	CREAMIVORY: 'CreamIvory',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	GREENLIGHT: 'GreenLight',
	GREENDARK: 'GreenDark',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROONBURGUNDY: 'MaroonBurgundy',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVERALUMINUM: 'SilverAluminum',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};

export const IL_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const KS_COLOR_ENUM = {
	// Beige, Black, Blue, DarkBlue, LightBlue, Brown, Bronze, ChromeSteel, Copper, CreamIvory, Gold, Gray, Green, DarkGreen, LightGreen, Ivory, Lavender, MaroonBurgundy, Orange, Pink, Purple, Red, SilverAluminum, Tan, Turquoise, White, Yellow
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	DARKBLUE: 'DarkBlue',
	LIGHTBLUE: 'LightBlue',
	BROWN: 'Brown',
	BRONZE: 'Bronze',
	CHROMESTEEL: 'ChromeSteel',
	COPPER: 'Copper',
	CREAMIVORY: 'CreamIvory',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	DARKGREEN: 'DarkGreen',
	LIGHTGREEN: 'LightGreen',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROONBURGUNDY: 'MaroonBurgundy',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVERALUMINUM: 'SilverAluminum',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};
export const TX_COLOR_ENUM = {
	// Beige, Black, Blue, DarkBlue, LightBlue, Brown, Bronze, ChromeSteel, Copper, CreamIvory, Gold, Gray, Green, DarkGreen, LightGreen, Ivory, Lavender, MaroonBurgundy, Orange, Pink, Purple, Red, SilverAluminum, Tan, Turquoise, White, Yellow
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	DARKBLUE: 'DarkBlue',
	LIGHTBLUE: 'LightBlue',
	BROWN: 'Brown',
	BRONZE: 'Bronze',
	CHROMESTEEL: 'ChromeSteel',
	COPPER: 'Copper',
	CREAMIVORY: 'CreamIvory',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	DARKGREEN: 'DarkGreen',
	LIGHTGREEN: 'LightGreen',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROONBURGUNDY: 'MaroonBurgundy',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVERALUMINUM: 'SilverAluminum',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};

export const WI_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const MN_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const OK_COLOR_ENUM = {
	BLACK: 'Black',
	BLUE: 'Blue',
	BRONZE: 'Bronze',
	BROWN: 'Brown',
	COPPER: 'Copper',
	CREAM: 'Cream',
	DARKBLUE: 'DarkBlue',
	DARKGREEN: 'DarkGreen',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	LAVENDER: 'Lavender',
	LIGHTBLUE: 'LightBlue',
	LIGHTGREEN: 'LightGreen',
	MAROON: 'Maroon',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVER: 'Silver',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};

export const MT_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const WA_COLOR_ENUM = {
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	DARKBLUE: 'DarkBlue',
	LIGHTBLUE: 'LightBlue',
	BROWN: 'Brown',
	BRONZE: 'Bronze',
	CHROMESTEEL: 'ChromeSteel',
	COPPER: 'Copper',
	CREAMIVORY: 'CreamIvory',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	DARKGREEN: 'DarkGreen',
	LIGHTGREEN: 'LightGreen',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROONBURGUNDY: 'MaroonBurgundy',
	MULTICOLOR: 'Multicolor',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVERALUMINUM: 'SilverAluminum',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};

export const LA_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const NM_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const OH_COLOR_ENUM = {
	LIGHTBLUE: 'LightBlue',
	TURQUOISE: 'Turquoise',
	DARKBLUE: 'DarkBlue',
	BLUE: 'Blue',
	AMETHYST: 'Amethyst',
	PURPLE: 'Purple',
	LAVENDER: 'Lavender',
	MAUVE: 'Mauve',
	PINK: 'Pink',
	RED: 'Red',
	MAROON: 'Maroon',
	ORANGE: 'Orange',
	COPPER: 'Copper',
	BRONZE: 'Bronze',
	TAN: 'Tan',
	GOLD: 'Gold',
	YELLOW: 'Yellow',
	LIGHTGREEN: 'LightGreen',
	GREEN: 'Green',
	DARKGREEN: 'DarkGreen',
	TEAL: 'Teal',
	BROWN: 'Brown',
	CREAM: 'Cream',
	BEIGE: 'Beige',
	TAUPE: 'Taupe',
	SILVER: 'Silver',
	CHROME: 'Chrome',
	GRAY: 'Gray',
	BLACK: 'Black',
	WHITE: 'White',
	CAMOUFLAGE: 'Camouflage',
	MULTICOLORED: 'MultiColored',
};

export const CO_COLOR_ENUM = {
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	DARKBLUE: 'DarkBlue',
	LIGHTBLUE: 'LightBlue',
	BROWN: 'Brown',
	BRONZE: 'Bronze',
	BURGUNDY: 'Burgundy',
	CHROME: 'Chrome',
	COPPER: 'Copper',
	CREAM: 'Cream',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	DARKGREEN: 'DarkGreen',
	LIGHTGREEN: 'LightGreen',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROON: 'Maroon',
	MAUVEPURPLE: 'MauvePurple',
	MULTICOLORED: 'Multicolored',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PLATINUM: 'Platinum',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVER: 'Silver',
	STEEL: 'Steel',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};

export const GA_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const NY_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const FL_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const MO_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const ID_COLOR_ENUM = INTERNAL_COLOR_ENUM;

export const TN_COLOR_ENUM = {
	ALUMINUM: 'Aluminum',
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	BLUEDARK: 'BlueDark',
	BLUELIGHT: 'BlueLight',
	BRONZE: 'Bronze',
	BROWN: 'Brown',
	BURGUNDY: 'Burgundy',
	CAMOUFLAGE: 'Camouflage',
	CHROME: 'Chrome',
	COPPER: 'Copper',
	CREAM: 'Cream',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	GREENDARK: 'GreenDark',
	GREENLIGHT: 'GreenLight',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROON: 'Maroon',
	MAUVEPURPLE: 'MauvePurple',
	MULTICOLORED: 'Multicolored',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVER: 'Silver',
	STAINLESSSTEEL: 'StainlessSteel',
	TAN: 'Tan',
	TAUPEBROWN: 'TaupeBrown',
	TEALGREEN: 'TealGreen',
	TURQUOISEBLUE: 'TurquoiseBlue',
	WHITE: 'White',
	YELLOW: 'Yellow',
	UNDEFINED: 'Undefined',
};

export const ND_COLOR_ENUM = {
	BEIGE: 'Beige',
	BLACK: 'Black',
	BLUE: 'Blue',
	BLUEDARK: 'BlueDark',
	BLUELIGHT: 'BlueLight',
	BROWN: 'Brown',
	BRONZE: 'Bronze',
	CHROMESTEEL: 'ChromeSteel',
	COPPER: 'Copper',
	CREAMIVORY: 'CreamIvory',
	GOLD: 'Gold',
	GRAY: 'Gray',
	GREEN: 'Green',
	GREENDARK: 'GreenDark',
	GREENLIGHT: 'GreenLight',
	IVORY: 'Ivory',
	LAVENDER: 'Lavender',
	MAROONBURGUNDY: 'MaroonBurgundy',
	ORANGE: 'Orange',
	PINK: 'Pink',
	PURPLE: 'Purple',
	RED: 'Red',
	SILVERALUMINUM: 'SilverAluminum',
	TAN: 'Tan',
	TURQUOISE: 'Turquoise',
	WHITE: 'White',
	YELLOW: 'Yellow',
};

export const INTERNAL_BODY_TYPE_ENUM = {
	AMBULANCE: 'Ambulance',
	BUS: 'Bus',
	CABRIOLET: 'Cabriolet',
	CAMPER_TRAILER: 'CamperTrailer',
	CONVERTIBLE: 'Convertible',
	COUPE2D: 'Coupe2D',
	HATCHBACK3D: 'Hatchback3D',
	LIMOUSINE: 'Limousine',
	MANUFACTURED_HOME: 'ManufacturedHome',
	MOTORCYCLE: 'Motorcycle',
	MOTORHOME: 'MotorHome',
	MULTIPURPOSETRAILER: 'MultipurposeTrailer',
	PASSENGERVAN: 'PassengerVan',
	PICKUP: 'Pickup',
	ROADSTER: 'Roadster',
	SEDAN4D: 'Sedan4D',
	SPECIAL_MOBILE_MACHINERY: 'SpecialMobileMachinery',
	STATIONWAGON5D: 'StationWagon5D',
	TRACTOR: 'Tractor',
	TRAILER: 'Trailer',
	TRAILER_COACH: 'TrailerCoach',
	TRAILER_UTILITY: 'TrailerUtility',
	TRUCK: 'Truck',
	TRUCK_TRACTOR: 'TruckTractor',
	TRUCK_VAN: 'TruckVan',
	UTILITY_PASSENGER_SUV: 'UtilityPassengerSUV',
	UTILITY_TRUCK: 'UtilityTruck',
	TWODOOR: 'TwoDoor',
	FOURDOOR: 'FourDoor',
	GO_KART: 'Gokart',
	E_BIKE: 'E-Bike',
};

export const NJ_BODY_TYPE_ENUM = {
	TWODOOR: 'TwoDoor',
	FOURDOOR: 'FourDoor',
	PICKUPTRUCK: 'PickupTruck',
	TRUCK: 'Truck',
	VAN: 'Van',
	WAGON: 'Wagon',
	MOTORCYCLE: 'Motorcycle',
	TRAILER: 'Trailer',
	CONVERTIBLE: 'Convertible',
	TRACTOR: 'Tractor',
	MOTORHOME: 'Motorhome',
};

export const NY_BODY_TYPE_ENUM = {
	TWODOOR: 'TwoDoor',
	FOURDOOR: 'FourDoor',
	CONVERTIBLE: 'Convertible',
	SUBURBANSUV: 'SuburbanSUV',
	PICKUP: 'PickUp',
	LIMO: 'Limo',
	MOTORCYCLE: 'Motorcycle',
	VAN: 'Van',
	TOW: 'Tow',
	TRAILER: 'Trailer',
	OTHER: 'Other',
};

export const VA_BODY_TYPE_ENUM = {
	MOTORCYCLE: 'Motorcycle',
	CABRIOLET: 'Cabriolet', // CABRIOLET in VA Body Type Enum (not in swagger)
};

export const MI_BODY_TYPE_ENUM = {
	TWODOOR: 'TwoDoor',
	FOURDOOR: 'FourDoor',
	AMBULANCE: 'Ambulance',
	BUS: 'Bus',
	CONVERTIBLE: 'Convertible',
	DUMP: 'Dump',
	HEARSE: 'Hearse',
	INCOMPLETE: 'Incomplete',
	LOWSPEEDVEHICLE: 'LowSpeedVehicle',
	MIXER: 'Mixer',
	MOTORHOME: 'Motorhome',
	MOTORCYCLE: 'Motorcycle',
	PANEL: 'Panel',
	PICKUP: 'Pickup',
	ROADSTER: 'Roadster',
	STAKE: 'Stake',
	STATIONWAGON: 'StationWagon',
	TANK: 'Tank',
	TRACTOR: 'Tractor',
	TRAILER: 'Trailer',
	TRAILERCOACH: 'TrailerCoach',
	UTILITY: 'Utility',
	VAN: 'Van',
	WRECKER: 'Wrecker',
};

export const CO_BODY_TYPE_ENUM = {
	AMBULANCE: 'Ambulance',
	BUS: 'Bus',
	CAMPER_TRAILER: 'CamperTrailer',
	CONVERTIBLE: 'Convertible',
	COUPE2D: 'Coupe2D',
	HATCHBACK3D: 'Hatchback3D',
	LIMOUSINE: 'Limousine',
	MANUFACTURED_HOME: 'ManufacturedHome',
	MOTORCYCLE: 'Motorcycle',
	MOTORHOME: 'MotorHome',
	MULTIPURPOSETRAILER: 'MultipurposeTrailer',
	PASSENGERVAN: 'PassengerVan',
	PICKUP: 'Pickup',
	ROADSTER: 'Roadster',
	SEDAN4D: 'Sedan4D',
	SPECIAL_MOBILE_MACHINERY: 'SpecialMobileMachinery',
	STATIONWAGON5D: 'StationWagon5D',
	TRACTOR: 'Tractor',
	TRAILER: 'Trailer',
	TRAILER_COACH: 'TrailerCoach',
	TRAILER_UTILITY: 'TrailerUtility',
	TRUCK: 'Truck',
	TRUCK_TRACTOR: 'TruckTractor',
	TRUCK_VAN: 'TruckVan',
	UTILITY_PASSENGER_SUV: 'UtilityPassengerSUV',
	UTILITY_TRUCK: 'UtilityTruck',
};

export const MT_BODY_TYPE_ENUM = {
	MOTORCYCLE: 'Motorcycle',
	SPORT_UTILITY_TRUCK: 'SportsUtilityTruck', // SPORT UTILITY TRUCK in MT Body Type Enum (not in swagger)
};

export const DEFAULT_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 125,
	CABRIOLET: 43,
};

export const NJ_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 6,
	FOURDOOR: 1,
};

export const VA_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 105,
	CABRIOLET: 15, // CABRIOLET in VA Body Type Enum (not in swagger)
};

export const TX_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 53,
	CONVERTIBLE: 22,
};

export const OR_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 31,
	CONVERTIBLE: 489,
};

export const NY_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 6,
	OTHER: 10,
};

export const MI_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 11,
	FOURDOOR: 1, // 4 door in MI Body Type Enum
};

export const PA_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 531,
	CABRIOLET: 519,
};

export const CO_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 8,
	UTILITY_PASSENGER_SUV: 24,
};

export const MT_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 157,
	SPORT_UTILITY_TRUCK: 200, // SPORT UTILITY TRUCK in MT Body Type Enum (not in swagger)
};

export const IL_BODY_TYPE_ID_ENUM = {
	MOTORCYCLE: 107,
	CABRIOLET: 20, // TODO
};

export const INTERNAL_CYLINDER_TYPE_ENUM = {
	ZERO: 'Zero',
	TWO: 'Two',
	FOUR: 'Four',
	FIVE: 'Five',
	SIX: 'Six',
	EIGHT: 'Eight',
	TEN: 'Ten',
	ROTARY: 'Rotary',
};

export const DEFAULT_CYLINDER_TYPE_ENUM = {
	ZERO: 'Zero',
	TWO: 'Two',
	FOUR: 'Four',
	SIX: 'Six',
	EIGHT: 'Eight',
};

export const AR_CYLINDER_TYPE_ENUM = {
	// Zero, Two, Four, Five, Six, Eight
	ZERO: 'Zero',
	TWO: 'Two',
	FOUR: 'Four',
	FIVE: 'Five',
	SIX: 'Six',
	EIGHT: 'Eight',
};

export const GA_CYLINDER_TYPE_ENUM = {
	ZERO: 'Zero',
	FOUR: 'Four',
	FIVE: 'Five',
	SIX: 'Six',
	EIGHT: 'Eight',
	TEN: 'Ten',
	ROTARY: 'Rotary',
};

// PLATE TYPE ENUMS
export const NM_PLATE_TYPE_ENUM = {
	CHILE_PLATE: 'ChilePlate',
};

export const MI_PLATE_TYPE_ENUM = {
	PURE_MICHIGAN_PLATE: 'PureMichiganPlate',
};

export const MS_PLATE_TYPE_ENUM = {
	REGULAR_PLATE: 'RegularPlate',
	HEARING_IMPAIRED_PLATE: 'HearingImpairedPlate',
	DIABETIC_PLATE: 'DiabeticPlate',
	BLACKOUT_PLATE: 'BlackoutPlate',
};

export const IL_PLATE_TYPE_ENUM = {
	// DisabledVeteranPlate, StandardDisabledPlate, HearingImpairedPlate
	DISABLED_VETERAN_PLATE: 'DisabledVeteranPlate',
	STANDARD_DISABLED_PLATE: 'StandardDisabledPlate',
	HEARING_IMPAIRED_PLATE: 'HearingImpairedPlate',
};

export const NV_PLATE_TYPE_ENUM = {
	PROFESSIONAL_FIREFIGHTER_PLATE: 'ProfessionalFirefighterPlate',
	PRISONER_OF_WAR_PLATE: 'PrisonerOfWarPlate',
	PURPLE_HEART_PLATE: 'PurpleHeartPlate',
	PEARL_HARBOR_VETERAN_PLATE: 'PearlHarborVeteranPlate',
	PEARL_HARBOR_SURVIVOR_PLATE: 'PearlHarborSurvivorPlate',
	CONGRESSIONAL_MEDAL_OF_HONOR_PLATE: 'CongressionalMedalOfHonorPlate',
	BRONZE_STAR_PLATE: 'BronzeStarPlate',
	SILVER_STAR_PLATE: 'SilverStarPlate',
	GOLD_STAR_PLATE: 'GoldStarPlate',
	AIR_FORCE_PLATE: 'AirForcePlate',
	AIR_NATIONAL_GUARD_PLATE: 'AirNationalGuardPlate',
	AIRBORNE_MILITARY_PLATE: 'AirborneMilitaryPlate',
	ARMY_NATIONAL_GUARD_PLATE: 'ArmyNationalGuardPlate',
	COAST_GUARD_PLATE: 'CoastGuardPlate',
	MARINE_CORPS_PLATE: 'MarineCorpsPlate',
	NAVY_LICENSE_PLATE: 'NavyLicensePlate',
	NAVY_SEABEES_PLATE: 'NavySeabeesPlate',
	DISABLED_VETERAN_PLATE: 'DisabledVeteranPlate',
	DISABLED_FEMALE_VETERAN_PLATE: 'DisabledFemaleVeteranPlate',
	AGRICULTURE_PLATE: 'AgriculturePlate',
	AMATEUR_RADIO_PLATE: 'AmateurRadioPlate',
	ANIMAL_APPRECIATION_PLATE: 'AnimalAppreciationPlate',
	AUTISM_AWARENESS_PLATE: 'AutismAwarenessPlate',
	CHILDHOOD_CANCER_AWARENESS_PLATE: 'ChildhoodCancerAwarenessPlate',
	CHILDREN_IN_THE_ARTS_PLATE: 'ChildrenInTheArtsPlate',
	CITIZENSHIP_PROJECT_PLATE: 'CitizenshipProjectPlate',
	CONSERVE_WILDLIFE_PLATE: 'ConserveWildlifePlate',
	DESERT_CONSERVATION_PLATE: 'DesertConservationPlate',
	GOLDEN_RULE_PLATE: 'GoldenRulePlate',
	HENDERSON_PLATE: 'HendersonPlate',
	HOOVER_DAM_PLATE: 'HooverDamPlate',
	HOT_AUGUST_NIGHTS_PLATE: 'HotAugustNightsPlate',
	LAKE_TAHOE_PLATE: 'LakeTahoePlate',
	LAS_VEGAS_CENTENNIAL_PLATE: 'LasVegasCentennialPlate',
	MISSING_EXPLOITED_CHILDREN_PLATE: 'MissingExploitedChildrenPlate',
	MOUNT_CHARLESTON_PLATE: 'MountCharlestonPlate',
	NEVADA_BIGHORNS_PLATE: 'NevadaBighornsPlate',
	NEVADA_FOREVER_STRONG_PLATE: 'NevadaForeverStrongPlate',
	NEVADA_HEALTH_CARE_PLATE: 'NevadaHealthCarePlate',
	NEVADA_TEST_SITE_PLATE: 'NevadaTestSitePlate',
	ORGAN_DONOR_PLATE: 'OrganDonorPlate',
	PYRAMID_LAKE_PLATE: 'PyramidLakePlate',
	RAIDERS_PLATE: 'RaidersPlate',
	RED_ROCK_CANYON_PLATE: 'RedRockCanyonPlate',
	RENO_AIR_RACES_PLATE: 'RenoAirRacesPlate',
	RODEO_PLATE: 'RodeoPlate',
	STEM_EDUCATION_PLATE: 'STEMEducationPlate',
	SUPPORT_WILDLIFE_PLATE: 'SupportWildlifePlate',
	UNITED_WE_STAND_PLATE: 'UnitedWeStandPlate',
	UNLV_COLLEGIATE_PLATE: 'UNLVCollegiatePlate',
	UNR_COLLEGIATE_PLATE: 'UNRCollegiatePlate',
	US_ARMY_PLATE: 'USArmyPlate',
	CIVIL_AIR_PATROL_PLATE: 'CivilAirPatrolPlate',
	EAGLE_SCOUT_OR_GIRL_SCOUT_PLATE: 'EagleScoutOrGirlScoutPlate',
	HONORARY_CONSUL_PLATE: 'HonoraryConsulPlate',
	MASONIC_LODGE_PLATE: 'MasonicLodgePlate',
	PRESS_PLATE: 'PressPlate',
	PEACE_OFFICER_PLATE: 'PeaceOfficerPlate',
	NATIONAL_GUARD_PLATE: 'NationalGuardPlate',
	FALLEN_MILITARY_PLATE: 'FallenMilitaryPlate',
	ELECTRIC_VEHICLE_PLATE: 'ElectricVehiclePlate',
	CIRCA_1982_REPLICA_PLATE: 'Circa1982ReplicaPlate',
	VEGAS_GOLDEN_KNIGHTS_PLATE: 'VegasGoldenKnightsPlate',
	VIRGINIA_AND_TRUCKEE_RAILROAD_PLATE: 'VirginiaAndTruckeeRailroadPlate',
	VOLUNTEER_FIRE_FIGHTER_PLATE: 'VolunteerFireFighterPlate',
	WOMENS_SUFFRAGE_PLATE: 'WomensSuffragePlate',
	WOMAN_VETERAN_PLATE: 'WomanVeteranPlate',
	DISABLED_PLATE: 'DisabledPlate',
	FRIENDS_OF_THE_METRO_PD: 'FriendsOfTheMetroPD',
	OPPORTUNITY_VILLAGE_PLATE: 'OpportunityVillagePlate',
	PUBLIC_EDUCATION_FOUNDATION_PLATE: 'PublicEducationFoundationPlate',
	LARGE_PLATE: 'LargePlate',
	SMALL_PLATE: 'SmallPlate',
	UNR_150_ANNIVERSARY_PLATE: 'UNR150AnniversaryPlate',
};

export const UT_PLATE_TYPE_ENUM = {
	IN_GOD_WE_TRUST: 'InGodWeTrust',
	LIFE_ELEVATED_ARCHES: 'LifeElevatedArches',
	LIFE_ELEVATED_SKIER: 'LifeElevatedSkier',
};

export const IN_PLATE_TYPE_ENUM = {
	DISABLED_PLATE: 'DisabledPlate',
	DISABLED_HOOSIER_VETERAN_PLATE: 'DisabledHoosierVeteranPlate',
	DISABLED_PURPLE_HEART_RECIPIENT_PLATE: 'DisabledPurpleHeartRecipientPlate',
	ARMED_FORCES_EXPEDITIONARY_MEDAL_PLATE: 'ArmedForcesExpeditionaryMedalPlate',
	GOLD_STAR_FAMILY_PLATE: 'GoldStarFamilyPlate',
	PURPLE_HEART_PLATE: 'PurpleHeartPlate',
	PRISONER_OF_WAR_PLATE: 'PrisonerOfWarPlate',
};

export const ID_PLATE_TYPE_ENUM = {
	Idaho4HPlate: 'Idaho4HPlate',
	ChooseLifePlate: 'ChooseLifePlate',
	MountainBikingLicensePlate: 'MountainBikingLicensePlate',
	SnowSkierLicensePlate: 'SnowSkierLicensePlate',
	WildlifePlate: 'WildlifePlate',
	PromoteAgricultureLicensePlate: 'PromoteAgricultureLicensePlate',
	IdahoAviationFoundationPlate: 'IdahoAviationFoundationPlate',
	PetLoversPlate: 'PetLoversPlate',
	SawtoothLicensePlate: 'SawtoothLicensePlate',
	SupportOurTroopsPlate: 'SupportOurTroopsPlate',
	AppaloosaLicensePlate: 'AppaloosaLicensePlate',
	FamousPotatoesPlate: 'FamousPotatoesPlate',
	IdahoRangelandLicensePlate: 'IdahoRangelandLicensePlate',
	PoliceOfficerMemorialLicensePlate: 'PoliceOfficerMemorialLicensePlate',
	SelwayBitterrootWildernessLicensePlate: 'SelwayBitterrootWildernessLicensePlate',
	TimberLicensePlate: 'TimberLicensePlate',
	CapitolCommissionLicensePlate: 'CapitolCommissionLicensePlate',
	FirefighterPlate: 'FirefighterPlate',
	LewisAndClarkLicensePlate: 'LewisAndClarkLicensePlate',
	SnowmobileLicensePlate: 'SnowmobileLicensePlate',
	WhiteWaterRaftingLicensePlate: 'WhiteWaterRaftingLicensePlate',
	YouthLicensePlate: 'YouthLicensePlate',
	StandardCentennialPlate: 'StandardCentennialPlate',
	MotorcyclePersonalizedPlate: 'MotorcyclePersonalizedPlate',
	StreetRodPlate: 'StreetRodPlate',
	PersonalizedStandardLicensePlate: 'PersonalizedStandardLicensePlate',
	VeteranPlate: 'VeteranPlate',
	NationalGuardLicensePlate: 'NationalGuardLicensePlate',
	MilitaryReserveLicensePlate: 'MilitaryReserveLicensePlate',
	GoldStarPlate: 'GoldStarPlate',
	PurpleHeartRecipientPlate: 'PurpleHeartRecipientPlate',
	AmateurRadioPlate: 'AmateurRadioPlate',
	PersonalizedDisabledLicensePlate: 'PersonalizedDisabledLicensePlate',
	StandardDisabilityPlate: 'StandardDisabilityPlate',
	DisabledVeteranRegistrationPlate: 'DisabledVeteranRegistrationPlate',
	DisabledVeteranPurpleHeartRecipientMedalPlate: 'DisabledVeteranPurpleHeartRecipientMedalPlate',
	BSUCollegiatePlate: 'BSUCollegiatePlate',
	BYUICollegiatePlate: 'BYUICollegiatePlate',
	CEICollegiatePlate: 'CEICollegiatePlate',
	CICollegiatePlate: 'CICollegiatePlate',
	CSICollegiatePlate: 'CSICollegiatePlate',
	ISUCollegiatePlate: 'ISUCollegiatePlate',
	LCSCCollegiatePlate: 'LCSCCollegiatePlate',
	NICCollegiatePlate: 'NICCollegiatePlate',
	NNUCollegiatePlate: 'NNUCollegiatePlate',
	UICollegiatePlate: 'UICollegiatePlate',
	CWICollegiatePlate: 'CWICollegiatePlate',
};

// REG PERIOD ENUMS

export const VT_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	TWO_YEARS: 'TwoYears',
	FIVE_YEARS: 'FiveYears',
};

export const UT_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	SIX_MONTHS: 'SixMonths',
};

export const OR_REG_PERIOD_TYPE_ENUM = {
	TWO_YEARS: 'TwoYears',
	FOUR_YEARS: 'FourYears',
	ONE_QUARTERS: 'OneQuarters',
	TWO_QUARTERS: 'TwoQuarters',
	THREE_QUARTERS: 'ThreeQuarters',
	FOUR_QUARTERS: 'FourQuarters',
};

export const NJ_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	TWO_YEARS: 'TwoYears',
	THREE_YEARS: 'ThreeYears',
	FOUR_YEARS: 'FourYears',
};

export const VA_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	TWO_YEARS: 'TwoYears',
	PERMANENT: 'Permanent',
};

export const MT_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	TWO_YEARS: 'TwoYears',
	PERMANENT: 'Permanent',
};

export const MO_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	TWO_YEARS: 'TwoYears',
	THREE_YEARS: 'ThreeYears',
	PERMANENT: 'Permanent',
};

export const NM_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	TWO_YEARS: 'TwoYears',
	PERMANENT: 'Permanent',
};

export const PA_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	TWO_YEARS: 'TwoYears',
	FIVE_YEARS: 'FiveYears',
	PERMANENT: 'Permanent',
};

export const NV_REG_PERIOD_TYPE_ENUM = {
	ONE_YEAR: 'OneYear',
	THREE_YEARS: 'ThreeYears',
};

// FILING TYPE ENUMS
export const WA_FILING_TYPE_ENUM = {
	TitleOnly: 'TitleOnly',
	TitleWithRegistration: 'TitleWithRegistration',
	Registration: 'Registration',
};

export const FL_TITLE_TYPE_ENUM = {
	ELECTRONIC: 'ElectronicTitle',
	PAPER: 'PaperTitle',
};

// REG SERVICE TYPE ENUMS
export const WA_REG_SERVICE_TYPE_ENUM = {
	ForTitleTransactions: 'ForTitleTransactions',
	TitleWithRegistration: 'TitleWithRegistration',
	AllOtherServices: 'AllOtherServices',
};

// USE TYPE ENUMS
export const INTERNAL_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FOR_HIRE: 'ForHire',
	OFFHIGHWAY: 'Offhighway',
};

export const DC_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const RI_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const ME_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const WV_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	OFFHIGHWAY: 'Offhighway',
};

export const VT_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const SD_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM_PRODUCTION: 'FarmProduction',
	FOR_HIRE: 'ForHire',
};

export const IA_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const NE_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FOR_HIRE: 'ForHire',
};

export const AL_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FOR_HIRE: 'ForHire',
};

export const KY_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const ID_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM_PRODUCTION: 'OffHighway',
};

export const MA_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM_PRODUCTION: 'FarmProduction',
};

export const CT_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	COMBINATION: 'Combination',
	CLASSIC: 'Classic',
	REGULAR: 'Regular',
	HEAVY_DUTY: 'HeavyDuty',
	SEASONAL: 'Seasonal',
	SEMITRAILER: 'SemiTrailer',
	FARM: 'Farm',
	SERVICE_BUS: 'ServiceBus',
	VANPOOL: 'Vanpool',
};

export const NJ_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	RENTAL: 'Rental',
};

export const MD_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	FARM_VEHICLE: 'FarmVehicle',
	ISLAND_VEHICLE: 'IslandVehicle',
	OFFHIGHWAY: 'OffHighway',
	CONSTRUCTION_VEHICLE: 'ConstructionVehicle',
};

export const TX_USE_TYPE_ENUM = {
	// Personal, Commercial, OffHighway
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	OFFHIGHWAY: 'OffHighway',
};

export const WI_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	DUAL_PURPOSE: 'DualPurpose',
};

export const WY_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const OR_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const MN_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM_PRODUCTION: 'FarmProduction',
	FOR_HIRE: 'ForHire',
	RECREATIONAL: 'Recreational',
};

export const OK_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM: 'Farm',
	FOREST: 'Forest',
};

export const NC_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FOR_HIRE: 'ForHire',
};

export const CO_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const SC_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const GA_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FOR_HIRE: 'ForHire',
	COMMERCIAL_FARM: 'CommercialFarm',
};

export const LA_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const TN_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const MI_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM: 'Farm',
	FOR_HIRE: 'ForHire',
};

export const NM_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
};

export const MT_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	OFFHIGHWAY: 'OffHighway',
	COMMERCIAL: 'Commercial',
	PERSONALOFFHIGHWAY: 'PersonalOffHighway',
};

export const NY_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM_VEHICLE: 'FarmVehicle',
	FOR_HIRE: 'ForHire',
};

export const PA_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FOR_HIRE: 'ForHire',
};

export const VA_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	FARM_PRODUCTION: 'FarmProduction',
	FOR_HIRE: 'ForHire',
};

export const WA_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	OFFHIGHWAY: 'Offhighway',
	FARM_PRODUCTION: 'FarmProduction',
	GOVERNMENT: 'Government',
	EXEMPT: 'Exempt',
};

export const NV_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	OFFHIGHWAY: 'OffHighway',
};

export const UT_USE_TYPE_ENUM = {
	PERSONAL: 'Personal',
	COMMERCIAL: 'Commercial',
	FARM_VEHICLE: 'FarmVehicle',
	FOR_HIRE: 'ForHire',
	OFFHIGHWAY: 'OffHighway',
};

export const INTERNAL_NUMBER_WHEELS_ENUM = {
	TWO: 2,
	THREE: 3,
};

// NUMBER OF MOTORCYCLE WHEELS ENUM

export const MO_NUMBER_WHEELS_ENUM = {
	TWO: 'TwoWheel',
	THREE: 'ThreeWheel',
};

export const SD_NUMBER_OF_WHEELS_ENUM = {
	ONE: 'OneWheel',
	TWO: 'TwoWheels',
	THREE: 'ThreeWheels',
	FOUR: 'FourWheels',
	FIVE: 'FiveWheels',
	SIX: 'SixWheels',
	SEVEN: 'SevenWheels',
	EIGHT: 'EightWheels',
};

export const INTERNAL_ID_TYPE_ENUM = {
	MA_LICENSE_ID: 'MALicenseID',
	OUT_OF_STATE_LICENSE: 'OutOfStateLicense',
	OUT_OF_COUNTRY_LICENSE: 'OutOfCountryLicense',
	SOCIAL_SECURITY_NUMBER: 'SocialSecurityNumber',
	LAWFUL_PRESENCE: 'LawfulPresence',
	STATE_ID: 'StateID',
	DRIVER_LICENSE: 'DriverLicense',
	US_PASSPORT_PASSPORT_CARD: 'USPassport_PassportCard',
	VALID_US_MILITARY_ID: 'ValidUSMilitaryID',
	TRIBAL_IDENTIFICATION_CARD: 'TribalIdentificationCard',
	US_CITIZENSHIP_DOCUMENT: 'USCitizenshipDocument',
	VALID_FOREIGN_PASSPORT: 'ValidForeignPassport',
	CANADIAN_LICENSE_ID: 'CanadianLicenseID',
	MILITARY_ID: 'MilitaryID',
	PASSPORT: 'Passport',
	FOREIGN_ID: 'ForeignID',
};

export const INTERNAL_DOORS_ENUM = {
	TWO: 2,
	THREE: 3,
	FOUR: 4,
	FIVE: 5,
};

export const MA_DOORS_ENUM = {
	TWO: 'Two',
	THREE: 'Three',
	FOUR: 'Four',
	FIVE: 'Five',
};

export const INTERNAL_TRANSMISSION_ENUM = {
	MANUAL: 'Manual',
	AUTOMATIC: 'Automatic',
};

export const PAYMENT_TYPES = {
	// BUYER PAYMENTS
	STANDARD_RESERVATION: 'STANDARD_RESERVATION',
	LOAN_DOWNPAYMENT: 'LOAN_DOWNPAYMENT',
	CHECKOUT_FULL_PAYMENT: 'CHECKOUT_FULL_PAYMENT',
	KLARNA_CHECKOUT_FULL_PAYMENT: 'KLARNA_CHECKOUT_FULL_PAYMENT',
	IN_PERSON_PAYMENT: 'IN_PERSON_PAYMENT',
	EARLY_REMAINING_BALANCE: 'EARLY_REMAINING_BALANCE',
	LATE_REMAINING_BALANCE: 'LATE_REMAINING_BALANCE',
	LOAN_ADDITIONAL_DOWN: 'LOAN_ADDITIONAL_DOWN',
	// LENDER PAYMENTS
	LENDER_FULL_PAYMENT: 'LENDER_FULL_PAYMENT',
	// NON-EKHO PRECHECKOUT PAYMENTS
	PRECHECKOUT: 'PRECHECKOUT',
	// EKHO COLLECTED PREORDER PAYMENTS
	PREORDER_RESERVATION: 'PREORDER_RESERVATION',
	PREORDER_VIP_RESERVATION: 'PREORDER_VIP_RESERVATION',
};

// The payment intent types that originate from checkout
export const CHECKOUT_PAYMENT_TYPES = [
	PAYMENT_TYPES.CHECKOUT_FULL_PAYMENT,
	PAYMENT_TYPES.STANDARD_RESERVATION,
	PAYMENT_TYPES.LOAN_DOWNPAYMENT,
	PAYMENT_TYPES.KLARNA_CHECKOUT_FULL_PAYMENT,
];

export const PREORDER_PAYMENT_TYPES = [
	PAYMENT_TYPES.PREORDER_RESERVATION,
	PAYMENT_TYPES.PREORDER_VIP_RESERVATION,
];

export const BUYER_PORTAL_PAYMENT_TYPES = [
	PAYMENT_TYPES.EARLY_REMAINING_BALANCE,
	PAYMENT_TYPES.LATE_REMAINING_BALANCE,
	PAYMENT_TYPES.LOAN_ADDITIONAL_DOWN,
];

export const DISCOUNT_TYPES = {
	PERCENTAGE_DISCOUNT: 'PERCENTAGE_DISCOUNT',
	FIXED_AMOUNT_DISCOUNT: 'FIXED_AMOUNT_DISCOUNT',
	SHIPPING_DISCOUNT: 'SHIPPING_DISCOUNT',
};

export const DISCOUNT_CATEGORIES = {
	REENGAGEMENT_DISCOUNT: 'REENGAGEMENT_DISCOUNT',
	DISCOUNT_CAMPAIGN: 'DISCOUNT_CAMPAIGN',
	CUSTOM_DISCOUNT: 'CUSTOM_DISCOUNT',
	FULL_PAYMENT_DISCOUNT: 'FULL_PAYMENT_DISCOUNT',
};

// The 3 different umbrella descriptions of all payment intent types
export const PAYMENT_DESCRIPTION_TYPES = {
	PREORDER_PAYMENT: {
		description: 'Preorder Payment',
		paymentTypes: [PAYMENT_TYPES.PREORDER_RESERVATION, PAYMENT_TYPES.PREORDER_VIP_RESERVATION],
	},
	RESERVATION_PAYMENT: {
		description: 'Reservation Payment',
		paymentTypes: [PAYMENT_TYPES.STANDARD_RESERVATION, PAYMENT_TYPES.LOAN_DOWNPAYMENT],
	},
	REMAINING_BALANCE_PAYMENT: {
		description: 'Remaining Balance Payment',
		paymentTypes: [
			PAYMENT_TYPES.EARLY_REMAINING_BALANCE,
			PAYMENT_TYPES.LATE_REMAINING_BALANCE,
			PAYMENT_TYPES.CHECKOUT_FULL_PAYMENT,
			PAYMENT_TYPES.KLARNA_CHECKOUT_FULL_PAYMENT,
			PAYMENT_TYPES.LENDER_FULL_PAYMENT,
		],
	},
	LOAN_ADDITIONAL_DOWN: {
		description: 'Loan Additional Down Payment',
		paymentTypes: [PAYMENT_TYPES.LOAN_ADDITIONAL_DOWN],
	},
};

export const PAYMENT_RECIPIENTS = {
	EKHO: 'EKHO',
	OEM: 'OEM',
};

// This is equivalent to 2 days (in milliseconds)
export const NUDGE_INACTIVE_BUYER = 172800000;
// This is equivalent to 1 week (in milliseconds)
export const NUDGE_BUYER_AGAIN = 604800000;

// The following are estimated due dates for BUYER_ACTION_ITEMS defined in getBuyerActionItems()
// 86400000 is equivalent to 1 day in milliseconds, so simply edit by multiplying by # of days
export const BUYER_DUE_DATES = {
	// Added to datePurchased
	SIGN_OFF_BY: 86400000 * 1,
	// Added to datePurchased
	FINANCE_BY: 86400000 * 3,
	// This is days since lender decision is given
	LOAN_DECISION_BY: 86400000 * 2,
	// Added to datePurchased
	REGISTRATION_BY: 86400000 * 5,
	// Added to datePurchased
	INSURANCE_BY: 86400000 * 10,
	// This is subtracted from estimatedDeliveryDate
	PAYMENT_BY: 86400000 * 10,
	// Added to datePurchased
	PAPERWORK_BY: 86400000 * 15,
};

export const BUYER_BLOCKED_ENUM = {
	VIN_NOT_ASSIGNED: 'VinNotAssigned',
	TAR_MANUAL_INTERVENTION_REQUIRED: 'TarManualInterventionRequired',
	ODOMETER_READING_NOT_ASSIGNED: 'OdometerReadingNotAssigned',
	NO_VALID_INSURANCE: 'NoValidInsurance',
	NO_FULFILLMENT_DETAILS: 'NoFulfillmentDetails',
	NO_FINANCING_DECISION: 'NoFinancingDecision',
	PAYMENT_PROCESSING: 'PaymentProcessing',
	NO_PAPERWORK_GENERATED: 'NoPaperworkGenerated',
};

// DEFAULTS FOR PLACED ORDERS AND VEHICLES THAT ARE OEM SPECIFIC
// Make sure to use the correct oemKey, and property name and value (i.e. odometerReading and value 1)
export const oemDefaults = {
	janus: {
		odometerReading: 1,
	},
	land: {
		odometerReading: 6,
	},
	maeving: {
		odometerReading: 6,
	},
	stark: {
		odometerReading: 5,
	},
	niu: {
		odometerReading: 5,
	},
	pave: {
		odometerReading: 3,
	},
	bakcou: {
		odometerReading: 5,
	},
	massimo: {
		odometerReading: 5,
	},
	// To add more later on
};

export const STARK_HPS = {
	SIXTY_HPS: 60,
	EIGHTY_HPS: 80,
};

export const OEM_REPORT_CATEGORY_ENUM = {
	SALES: 'Sales',
	FEES: 'Fees',
};

export const OEM_REPORT_KEY_ENUM = {
	SALES_BY_CUSTOMER_NAME: 'SalesByCustomerName',
	TAXES_AND_FEES_BY_VEHICLE: 'TaxesAndFeesByVehicle',
	OUTGOING_PAYMENTS: 'OutgoingPayments',
	FEES_BY_VEHICLE: 'FeesByVehicle',
};

export const ALL_REPORTS = [
	{
		key: OEM_REPORT_KEY_ENUM.SALES_BY_CUSTOMER_NAME,
		name: 'Sales by Customer Name',
		categories: [OEM_REPORT_CATEGORY_ENUM.SALES],
	},
	{
		key: OEM_REPORT_KEY_ENUM.FEES_BY_VEHICLE,
		name: 'Fees by Vehicle',
		categories: [OEM_REPORT_CATEGORY_ENUM.FEES],
	},
	{
		key: OEM_REPORT_KEY_ENUM.OUTGOING_PAYMENTS,
		name: 'Outgoing Payments',
		categories: [OEM_REPORT_CATEGORY_ENUM.FEES],
	},
	// Add more report definitions here in the future
];
export const TWILIO_TEST_NUMBER = '+15005550006';
export const TWILIO_PROD_NUMBER = '+18447530817';

export const TWILIO_SMS_MESSAGES = {
	ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
	PREORDER_CONFIRMATION: 'PREORDER_CONFIRMATION',
	PREORDER_CONVERSION: 'PREORDER_CONVERSION',
	LENDER_DECISION: 'LENDER_DECISION',
	CONDITIONAL_OFFER: 'CONDITIONAL_OFFER',
	RIC_SIGNATURE: 'RIC_SIGNATURE',
	ACH_FAILED: 'ACH_FAILED',
	CREDIT_APPLICATION_NOT_COMPLETED: 'CREDIT_APPLICATION_NOT_COMPLETED',
	STIPS_NOT_VALIDATED_AND_EVIDENCE_NEEDED: 'STIPS_NOT_VALIDATED_AND_EVIDENCE_NEEDED',
	FINANCING_DECISION_NOT_ACCEPTED: 'FINANCING_DECISION_NOT_ACCEPTED',
	IDENTITY_VERIFICATION_NOT_COMPLETED: 'IDENTITY_VERIFICATION_NOT_COMPLETED',
	BOS_NOT_SIGNED: 'BOS_NOT_SIGNED',
	DAILY_SALES_SUMMARY: 'DAILY_SALES_SUMMARY',
	CREDIT_REAPPLICATION_TRIGGERED: 'CREDIT_REAPPLICATION_TRIGGERED',
};

export const CREDIT_AGENCIES = {
	TRANSUNION: 'TransUnion',
	EXPERIAN: 'Experian',
	EQUIFAX: 'Equifax',
};

export const GOOGLE_AUTOCOMPLETE_LIBRARIES = ['places'];
export const GOOGLE_AUTOCOMPLETE_AND_MAPS_LIBRARIES = ['places', 'geometry'];
export const SENSITIVE_DATA_FIELDS = ['ssn', 'dob', 'dlNumber'];

export const STRIPE_CREDIT_CARD_FEE_PERCENT = 1 / (1 - 0.029) - 1;
export const STRIPE_TRANSACTION_FEE_AMOUNT = 0.3;
export const STRIPE_PAYOUT_FEE_PERCENT = 0.0025;

export const additionalFieldsMap = GOOGLE_AUTOCOMPLETE_LIBRARIES;
export const LOAD_TESTING_PAYMENT_INTENT_ID = 'pi_3PJFLMI47LxGASce1SbTqWow';

/* DEVELOPMENT/STAGING OEM CONSTS */
export const BP_OEM_KEY = 'bp-test-oem';
export const BP_OEM_ID = 'bp-test-oem-id';
export const BACKEND_BP_OEM_KEY = 'backend-bp-test-oem';
export const BACKEND_BP_OEM_ID = 'backend-bp-test-oem-id';
export const CHECKOUT_OEM_KEY = 'checkout-test-oem';
export const CHECKOUT_OEM_ID = 'checkout-test-oem-id';
export const DEV_OEM_KEY = 'dev-project-key';
export const DEV_BRAND_KEY = 'dev-brand-key';
export const DEV_OEM_ID = 'dev-oem-id';
export const DEMO_BRAND_KEY = 'demo-brand-key';
export const DEMO_OEM_ID = 'demo-oem-id';
/* END DEVELOPMENT/STAGING OEM CONSTS */

/* PROD OEM CONSTS */
export const JANUS_OEM_KEY = 'janus';
export const JANUS_OEM_ID = 'QczG5nHitwkBiiQBFiLW';
export const MOKE_OEM_KEY = 'moke';
export const MOKE_OEM_ID = '4FhrbkWLHYkGnLjsxh7S';
export const LAND_OEM_KEY = 'land';
export const LAND_OEM_ID = 'Dw11Hij5QzzTenm6Odbf';
export const PICKMAN_OEM_KEY = 'pickman';
export const PICKMAN_OEM_ID = 'GJBxwpJIcckYRUj2FRBE';
export const MAEVING_OEM_KEY = 'maeving';
export const MAEVING_OEM_ID = 'QZzao3tGSmDzt94SfAWG';
export const STARK_OEM_KEY = 'stark';
export const STARK_OEM_ID = 'Ju81l5hQ84wFV9M4qz5b';
export const POWERPLUS_OEM_KEY = 'powerplus';
export const POWERPLUS_OEM_ID = 'AACt7ZVbJOj72VLIImVp';
export const INFINITE_MACHINE_OEM_KEY = 'infinitemachine';
export const INFINITE_MACHINE_OEM_ID = 'Vmh8UEJmHNSp3y8V6Iah';
export const NAXEON_OEM_KEY = 'naxeon';
export const NAXEON_OEM_ID = 'PopnkzSwozYYHEVTgYji';
export const PINNED_OEM_KEY = 'pinnedelectric';
export const BAKCOU_OEM_KEY = 'bakcou';
export const BAKCOU_OEM_ID = 'VKECfSSBPRfgAhCf1Xtx';
export const NIU_OEM_KEY = 'niu';
export const NIU_OEM_ID = 'vRDPTlx0iYpapCrcVzYH';
export const ZERO_OEM_KEY = 'zero';
export const ZERO_OEM_ID = 'HtkZJuOQNvJcce1n7zJo';
export const DUST_OEM_KEY = 'dust';
export const DUST_OEM_ID = '18gXllTJbLOJwdffMOsb';
export const PAVE_OEM_KEY = 'pave';
export const PAVE_OEM_ID = 'zJ5qYxnHWHyreIV2nSI1';
export const LIVEWIRE_OEM_KEY = 'livewire';
export const LIVEWIRE_OEM_ID = 'x81l2N5CvgQjINb2MCbU';
export const MASSIMO_OEM_KEY = 'massimo';
export const MASSIMO_OEM_ID = 'SrwoTk9EU1H0KAaPFJBJ';
export const BONNELL_OEM_KEY = 'bonnell';
export const BONNELL_OEM_ID = 'Jw8udgBsAXMjrjLML49Y';
export const CCW_OEM_KEY = 'ccw';
export const CCW_OEM_ID = 'raCp4HgGXVEAOEfL1bDu';
export const RENA_OEM_KEY = 'rena';
export const RENA_OEM_ID = 'wmqi57D0VejCIfg6QGEA';
// BRANDS
export const ARCTIC_LEOPARD_BRAND_KEY = 'arcticleopard';
export const ARCTIC_LEOPARD_OEM_ID = 'VMkxU71XsTQEuNZrEppm';
export const VENTUS_BRAND_KEY = 'ventus';
export const VENTUS_OEM_ID = 'Drso8RcbqUuG6vHBbCUT';
export const BAKCOU_BRAND_KEY = 'bakcou';
export const NIU_BRAND_KEY = 'niu';
export const ZERO_BRAND_KEY = 'zero';
export const DUST_BRAND_KEY = 'dust';
export const PAVE_BRAND_KEY = 'pave';
export const LIVEWIRE_BRAND_KEY = 'livewire';
export const MASSIMO_BRAND_KEY = 'massimo';
export const BONNELL_BRAND_KEY = 'bonnell';
export const CCW_BRAND_KEY = 'ccw';
export const RENA_BRAND_KEY = 'rena';
/* END PROD OEM CONSTS */

export const INPUT_TYPES = {
	TEXT_INPUT: 'INPUT',
	SELECT: 'SELECT',
	CHECK: 'CHECK',
	CHECK_SELECT: 'CHECK_SELECT',
	DATE: 'DATE',
	ADDRESS: 'ADDRESS',
	TITLE_DIVIDER: 'TITLE_DIVIDER',
	TEXT_AREA: 'TEXT_AREA',
};

// Map from oemKey to firebase database project id
export const OEM_KEY_TO_PROJECT_MAP = {
	e2etestoem: 'e2etestoem-prod',
	janus: 'janus-prod-a3c47',
	moke: 'moke-3b4f5',
	land: 'land-prod-ddbc9',
	pickman: 'pickman-prod',
	maeving: 'maeving-prod',
	stark: 'stark-prod-631be',
	powerplus: 'powerplus-prod',
	naxeon: 'naxeon-prod',
	infinitemachine: 'infinitemachine-prod',
	[DEV_OEM_KEY]: 'airdealer-67669',
	pinnedelectric: 'pinned-prod',
	bakcou: 'bakcou-prod',
	niu: 'niu-prod-2e9d3',
	zero: 'zero-prod-8f2dc',
	dust: 'dust-prod-cfcf6',
	pave: 'pave-prod',
	livewire: 'livewire-prod',
	massimo: 'massimo-prod',
	bonnell: 'bonnell-prod',
	ccw: 'ccw-prod-04222025',
	rena: 'rena-prod',
};

export const oemMap: Record<string, string | Record<string, string>> = {
	[CHECKOUT_OEM_KEY]: CHECKOUT_OEM_ID,
	[BP_OEM_KEY]: BP_OEM_ID,
	e2etestoem: 'Ju81l5hQ84wFV9M4qz5b',
	[JANUS_OEM_KEY]: JANUS_OEM_ID,
	[MOKE_OEM_KEY]: MOKE_OEM_ID,
	[LAND_OEM_KEY]: LAND_OEM_ID,
	[PICKMAN_OEM_KEY]: PICKMAN_OEM_ID,
	[MAEVING_OEM_KEY]: MAEVING_OEM_ID,
	[STARK_OEM_KEY]: STARK_OEM_ID,
	[POWERPLUS_OEM_KEY]: POWERPLUS_OEM_ID,
	[INFINITE_MACHINE_OEM_KEY]: INFINITE_MACHINE_OEM_ID,
	[NAXEON_OEM_KEY]: NAXEON_OEM_ID,
	[PINNED_OEM_KEY]: {
		[ARCTIC_LEOPARD_BRAND_KEY]: ARCTIC_LEOPARD_OEM_ID,
		[VENTUS_BRAND_KEY]: VENTUS_OEM_ID,
	},
	[BAKCOU_OEM_KEY]: {
		[BAKCOU_BRAND_KEY]: BAKCOU_OEM_ID,
	},
	[NIU_OEM_KEY]: {
		[NIU_BRAND_KEY]: NIU_OEM_ID,
	},
	[ZERO_OEM_KEY]: {
		[ZERO_BRAND_KEY]: ZERO_OEM_ID,
	},
	[DUST_OEM_KEY]: {
		[DUST_BRAND_KEY]: DUST_OEM_ID,
	},
	[PAVE_OEM_KEY]: {
		[PAVE_BRAND_KEY]: PAVE_OEM_ID,
	},
	[LIVEWIRE_OEM_KEY]: {
		[LIVEWIRE_BRAND_KEY]: LIVEWIRE_OEM_ID,
	},
	[MASSIMO_OEM_KEY]: {
		[MASSIMO_BRAND_KEY]: MASSIMO_OEM_ID,
	},
	[BONNELL_OEM_KEY]: {
		[BONNELL_BRAND_KEY]: BONNELL_OEM_ID,
	},
	[CCW_OEM_KEY]: {
		[CCW_BRAND_KEY]: CCW_OEM_ID,
	},
	[RENA_OEM_KEY]: {
		[RENA_BRAND_KEY]: RENA_OEM_ID,
	},
	// DEV and DEMO
	[DEV_OEM_KEY]: {
		[DEV_BRAND_KEY]: DEV_OEM_ID,
		[DEMO_BRAND_KEY]: DEMO_OEM_ID,
	},
};

export const MIN_FIELDS_TO_COLLECT = {
	CARRIER_NAME: 'carrierName',
	POLICY_ID: 'policyId',
	EFFECTIVE_DATE: 'effectiveDate',
	EXPIRY_DATE: 'expiryDate',
	POLICY_NUMBER: 'carrierPolicyNumber',
	AGENT_OR_BROKER_NAME: 'agentBrokerName',
	POLICY_NAME: 'name',
	ISSUING_STATE: 'issuingState',
	POLICY_TYPE: 'policyType',
};

// map to stripe id document types
export const ID_DOCUMENT_TYPE_ENUM = {
	DRIVERS_LICENSE: 'driving_license',
	ID_CARD: 'id_card',
	PASSPORT: 'passport',
};

export const PROMOTION_TYPES = {
	FINANCING: 'FINANCING',
};

export const FinancingActionItemOptions = {
	WAIT_FOR_SUBMISSION_WINDOW: 'WAIT_FOR_SUBMISSION_WINDOW',
	SUBMIT_CREDIT_APP_AND_REPORT_DECISION: 'SUBMIT_CREDIT_APP_AND_REPORT_DECISION',
	GATHER_ADDITIONAL_INFO: 'GATHER_ADDITIONAL_INFO',
	PERFORM_PREAUDIT: 'PERFORM_PREAUDIT',
	SIGN_DOCS: 'SIGN_DOCS',
	SUBMIT_FUNDING_PACKAGE: 'SUBMIT_FUNDING_PACKAGE',
	WAIT_FOR_FUNDED_NOTICE: 'WAIT_FOR_FUNDED_NOTICE',
	BLOCKED: 'BLOCKED',
	COMPLETE: 'COMPLETE',
};

export const abbrevStateNamesArr = [
	'AL',
	'AK',
	'AS',
	'AZ',
	'AR',
	'CA',
	'CO',
	'CT',
	'DE',
	'DC',
	'FM',
	'FL',
	'GA',
	'GU',
	'HI',
	'ID',
	'IL',
	'IN',
	'IA',
	'KS',
	'KY',
	'LA',
	'ME',
	'MH',
	'MD',
	'MA',
	'MI',
	'MN',
	'MS',
	'MO',
	'MT',
	'NE',
	'NV',
	'NH',
	'NJ',
	'NM',
	'NY',
	'NC',
	'ND',
	'MP',
	'OH',
	'OK',
	'OR',
	'PW',
	'PA',
	'PR',
	'RI',
	'SC',
	'SD',
	'TN',
	'TX',
	'UT',
	'VT',
	'VI',
	'VA',
	'WA',
	'WV',
	'WI',
	'WY',
];

// FOR BELOW FIELDS MAP:

// If type is INPUT_TYPES.CHECK
// - needs fields:
//   - checkLabel
//   - type: INPUT_TYPES.CHECK
//   - label
//   - yup
// 	 - title

// If type is INPUT_TYPES.INPUT
// - needs fields:
//   - inputType (text, date, tel)
//   - type: INPUT_TYPES.INPUT
//   - label
//   - yup
//   - title

// If type is INPUT_TYPES.SELECT
// - needs fields:
//   - list: [
//			{ value: <val_1>, text: <display_text_1> },
//  		{ value: <val_2,  text: <display_text_2> },
//  		...
// 		]
//   - type: INPUT_TYPES.INPUT
//   - label
//   - yup
//   - title

export const ADDITIONAL_FIELDS_MAP = {
	isOwnerResident: {
		type: INPUT_TYPES.CHECK_SELECT,
		checkLabel: 'Are you a resident of the registration state?',
		label: 'Are you a resident of the registration state?',
		yup: Yup.boolean().required('Required'),
		title: 'Residency status',
		defaultValue: true,
	},
	addressIsInUnincorporatedArea: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Is your address in an unincorporated area?',
		label: 'Is your address in an unincorporated area?',
		yup: Yup.boolean().required('Required'),
		title: 'Unincorporated area',
		defaultValue: true,
	},
	ssn: {
		type: INPUT_TYPES.TEXT_INPUT,
		inputType: 'text',
		label: 'Social Security Number',
		yup: Yup.string()
			.required('SSN is required')
			.matches(
				/^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/,
				'Please ensure your SSN is in the correct format',
			),
		title: 'Social Security Number',
		mask: '999-99-9999',
	},
	isOwnerSpouseOfMilitary: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Are you the spouse of a member of the military?',
		label: 'Spouse to military member',
		yup: Yup.boolean().required('Required'),
		title: 'Owner is spouse to military member',
		defaultValue: true,
	},
	recreationalPassportFee: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to include the Recreational Passport with registration?',
		label: 'Recreational Passport',
		yup: Yup.boolean().required('Required'),
		title: 'Recreational Passport',
		defaultValue: true,
	},
	keepColoradoWildPass: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to include the Keep Colorado Wild Pass with registration?',
		label: 'Keep Colorado Wild Pass',
		yup: Yup.boolean().required('Required'),
		title: 'Keep Colorado Wild Pass',
		defaultValue: true,
	},
	temporarilyLivingOutOfState: {
		type: INPUT_TYPES.CHECK_SELECT,
		checkLabel: 'Are you temporarily living out of state?',
		label: 'Temporarily out of state',
		yup: Yup.boolean().required('Required'),
		title: 'Temporarily out of state',
		defaultValue: true,
	},
	inOreGo: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to Enroll in OreGO with registration?',
		label: 'OreGO enrollment',
		yup: Yup.boolean().required('Required'),
		title: 'OreGO enrollment',
		defaultValue: true,
	},
	registrationRenewalReminder: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to receive registration renewal reminders by email?',
		label: 'Registration renewal reminder',
		yup: Yup.boolean().required('Required'),
		title: 'Registration renewal reminder',
		defaultValue: true,
	},
	applyingForWildlifeParksPermit: {
		type: INPUT_TYPES.CHECK,
		checkLabel: 'Do you want to apply for a wildlife park permit?',
		label: 'Wildlife park permit',
		yup: Yup.boolean().required('Required'),
		title: 'Wildlife park permit',
		defaultValue: true,
	},
	stateStationed: {
		type: INPUT_TYPES.TEXT_INPUT,
		inputType: 'text',
		label: 'State Stationed for Military',
		yup: Yup.string().oneOf(
			abbrevStateNamesArr,
			'Please enter a valid US state abbreviation. E.g. enter CA for California.',
		),
		title: 'State Stationed for Military',
		defaultValue: '',
	},
	// vehicleStorageAddress: {
	// 	type: INPUT_TYPES.ADDRESS,
	// 	inputType: 'text',
	// 	label: 'Vehicle storage address',
	// 	yup: Yup.string(),
	// 	title: 'Vehicle storage address',
	// },
	eyeColor: {
		type: INPUT_TYPES.TEXT_INPUT,
		inputType: 'text',
		label: 'Eye Color',
		yup: Yup.string().nullable().required('Required'),
		title: 'Eye Color as in Drivers License',
		defaultValue: 'Brown',
	},
};

export const usStatesForSelect = [
	{ value: 'AL', text: 'Alabama' },
	{ value: 'AK', text: 'Alaska' },
	{ value: 'AZ', text: 'Arizona' },
	{ value: 'AR', text: 'Arkansas' },
	{ value: 'CA', text: 'California' },
	{ value: 'CO', text: 'Colorado' },
	{ value: 'CT', text: 'Connecticut' },
	{ value: 'DC', text: 'Washington, D.C.' },
	{ value: 'DE', text: 'Delaware' },
	{ value: 'FL', text: 'Florida' },
	{ value: 'GA', text: 'Georgia' },
	{ value: 'HI', text: 'Hawaii' },
	{ value: 'ID', text: 'Idaho' },
	{ value: 'IL', text: 'Illinois' },
	{ value: 'IN', text: 'Indiana' },
	{ value: 'IA', text: 'Iowa' },
	{ value: 'KS', text: 'Kansas' },
	{ value: 'KY', text: 'Kentucky' },
	{ value: 'LA', text: 'Louisiana' },
	{ value: 'ME', text: 'Maine' },
	{ value: 'MD', text: 'Maryland' },
	{ value: 'MA', text: 'Massachusetts' },
	{ value: 'MI', text: 'Michigan' },
	{ value: 'MN', text: 'Minnesota' },
	{ value: 'MS', text: 'Mississippi' },
	{ value: 'MO', text: 'Missouri' },
	{ value: 'MT', text: 'Montana' },
	{ value: 'NE', text: 'Nebraska' },
	{ value: 'NV', text: 'Nevada' },
	{ value: 'NH', text: 'New Hampshire' },
	{ value: 'NJ', text: 'New Jersey' },
	{ value: 'NM', text: 'New Mexico' },
	{ value: 'NY', text: 'New York' },
	{ value: 'NC', text: 'North Carolina' },
	{ value: 'ND', text: 'North Dakota' },
	{ value: 'OH', text: 'Ohio' },
	{ value: 'OK', text: 'Oklahoma' },
	{ value: 'OR', text: 'Oregon' },
	{ value: 'PA', text: 'Pennsylvania' },
	{ value: 'RI', text: 'Rhode Island' },
	{ value: 'SC', text: 'South Carolina' },
	{ value: 'SD', text: 'South Dakota' },
	{ value: 'TN', text: 'Tennessee' },
	{ value: 'TX', text: 'Texas' },
	{ value: 'UT', text: 'Utah' },
	{ value: 'VT', text: 'Vermont' },
	{ value: 'VA', text: 'Virginia' },
	{ value: 'WA', text: 'Washington' },
	{ value: 'WV', text: 'West Virginia' },
	{ value: 'WI', text: 'Wisconsin' },
	{ value: 'WY', text: 'Wyoming' },
];

export const usStatesArray = [
	'Alabama',
	'Alaska',
	'American Samoa',
	'Arizona',
	'Arkansas',
	'California',
	'Colorado',
	'Connecticut',
	'Delaware',
	'District of Columbia',
	'Federated States of Micronesia',
	'Florida',
	'Georgia',
	'Guam',
	'Hawaii',
	'Idaho',
	'Illinois',
	'Indiana',
	'Iowa',
	'Kansas',
	'Kentucky',
	'Louisiana',
	'Maine',
	'Marshall Islands',
	'Maryland',
	'Massachusetts',
	'Michigan',
	'Minnesota',
	'Mississippi',
	'Missouri',
	'Montana',
	'Nebraska',
	'Nevada',
	'New Hampshire',
	'New Jersey',
	'New Mexico',
	'New York',
	'North Carolina',
	'North Dakota',
	'Northern Mariana Islands',
	'Ohio',
	'Oklahoma',
	'Oregon',
	'Palau',
	'Pennsylvania',
	'Puerto Rico',
	'Rhode Island',
	'South Carolina',
	'South Dakota',
	'Tennessee',
	'Texas',
	'Utah',
	'Vermont',
	'Virgin Island',
	'Virginia',
	'Washington',
	'Washington, D.C.',
	'West Virginia',
	'Wisconsin',
	'Wyoming',
];

export const CREDIT_APP_FIELD_IDS = {
	DOWN_PAYMENT_AMT: 'downpaymentAmt',
	LOAN_TERM: 'loanTerm',
	PHONE_NUMBER: 'phoneNumber',
	DOB: 'dob',
	SSN: 'ssn',
	MARITAL_STATUS: 'maritalStatus',
	HOME_ADDRESS_SAME_AS_ID_ADDRESS: 'homeAddressSameAsIdAddress',
	HOUSING_OWNERSHIP: 'housingOwnership',
	HOME_MOVE_IN_DATE: 'homeMoveInDate',
	MONTHLY_AMT: 'monthlyAmt',
	EMPLOYMENT_STATUS: 'employmentStatus',
	MONTHLY_GROSS_INCOME: 'monthlyGrossIncome',
	EMPLOYER_NAME: 'employerName',
	EMPLOYER_PHONE_NUMBER: 'employerPhoneNumber',
	OCCUPATION: 'occupation',
	JOB_START_DATE: 'jobStartDate',
	NOTE_TO_LENDER: 'noteToLender',
};

export const FINANCING_BANK_NAME_ENUM = {
	FRF: 'FRF',
	IRONHORSE: 'IRONHORSE',
};

export const FINANCING_BANK_NAME_ENUM_DISPLAY = {
	[FINANCING_BANK_NAME_ENUM.FRF]: 'Freedom Road Financial',
	[FINANCING_BANK_NAME_ENUM.IRONHORSE]: 'Ironhorse Funding',
};

export const COLORS = {
	PRIMARY: {
		name: 'primary',
		code: process.env.REACT_APP_PRIMARY_COLOR,
	},
	SECONDARY: {
		name: 'secondary',
		code: process.env.REACT_APP_SECONDARY_COLOR,
	},
	SUCCESS: {
		name: 'success',
		code: process.env.REACT_APP_SUCCESS_COLOR,
	},
	INFO: {
		name: 'info',
		code: process.env.REACT_APP_INFO_COLOR,
	},
	WARNING: {
		name: 'warning',
		code: process.env.REACT_APP_WARNING_COLOR,
	},
	DANGER: {
		name: 'danger',
		code: process.env.REACT_APP_DANGER_COLOR,
	},
	DARK: {
		name: 'dark',
		code: process.env.REACT_APP_DARK_COLOR,
	},
	LIGHT: {
		name: 'light',
		code: process.env.REACT_APP_LIGHT_COLOR,
	},
	// Color Hex codes
	BACKGROUND_GRAY: {
		name: 'backgroundGray',
		code: '#f8f9fa',
	},
	BORDER_GRAY: {
		name: 'borderGray',
		code: 'var(--bs-card-border-color)',
	},
};

// Used for FRF credit app. Don't change!
export const STATE_ABBREV_TO_STATE_NAME = {
	AL: 'Alabama',
	AK: 'Alaska',
	AZ: 'Arizona',
	AR: 'Arkansas',
	CA: 'California',
	CO: 'Colorado',
	CT: 'Connecticut',
	DE: 'Delaware',
	FL: 'Florida',
	GA: 'Georgia',
	HI: 'Hawaii',
	ID: 'Idaho',
	IL: 'Illinois',
	IN: 'Indiana',
	IA: 'Iowa',
	KS: 'Kansas',
	KY: 'Kentucky',
	LA: 'Louisiana',
	ME: 'Maine',
	MD: 'Maryland',
	MA: 'Massachusetts',
	MI: 'Michigan',
	MN: 'Minnesota',
	MS: 'Mississippi',
	MO: 'Missouri',
	MT: 'Montana',
	NE: 'Nebraska',
	NV: 'Nevada',
	NH: 'New Hampshire',
	NJ: 'New Jersey',
	NM: 'New Mexico',
	NY: 'New York',
	NC: 'North Carolina',
	ND: 'North Dakota',
	OH: 'Ohio',
	OK: 'Oklahoma',
	OR: 'Oregon',
	PA: 'Pennsylvania',
	RI: 'Rhode Island',
	SC: 'South Carolina',
	SD: 'South Dakota',
	TN: 'Tennessee',
	TX: 'Texas',
	UT: 'Utah',
	VT: 'Vermont',
	VA: 'Virginia',
	WA: 'Washington',
	WV: 'West Virginia',
	WI: 'Wisconsin',
	WY: 'Wyoming',
};

export const TITLING_AGENT_ENUM = {
	LENDER: 'LENDER',
	EKHO: 'EKHO',
	NONE: 'NONE',
};

// UPDATED JAN 2 2024
// Note: If an APR is not specified for a given term, it means lender doesn't offer it. If newVehicleApr is not defined, DON'T LIST THAT TEIR
// export const ekhoFinancingPrograms = {
// 	[FINANCING_BANK_NAME_ENUM.FRF]: {
// 		STREET_DIRT_PROGRAM: {
// 			programKey: 'STREET_DIRT_PROGRAM',
// 			lastUpdated: 'January 2, 2024',
// 			minimumLoanAmount: 2500,
// 			loanApprovalGoodForDays: 30,
// 			tiers: [
// 				{
// 					tierNum: 1,
// 					creditScoreMax: 850,
// 					creditScoreMin: 730,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0899,
// 							usedVehicleApr: 0.0999,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0899,
// 							usedVehicleApr: 0.0999,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0899,
// 							usedVehicleApr: 0.0999,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1199,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1129,
// 							usedVehicleApr: 0.1299,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 2,
// 					creditScoreMax: 729,
// 					creditScoreMin: 700,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1199,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1299,
// 							usedVehicleApr: 0.1399,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 3,
// 					creditScoreMax: 699,
// 					creditScoreMin: 675,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1549,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 4,
// 					creditScoreMax: 674,
// 					creditScoreMin: 660,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1549,
// 							usedVehicleApr: 0.1649,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 5,
// 					creditScoreMax: 659,
// 					creditScoreMin: 0,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1899,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1899,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1899,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1999,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1899,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 			],
// 			titlingAgent: TITLING_AGENT_ENUM.EKHO,
// 		},
// 		ATV_ORV_PROGRAM: {
// 			programKey: 'ATV_ORV_PROGRAM',
// 			lastUpdated: 'January 2, 2024', // The current date, assuming this is the update date.
// 			minimumLoanAmount: 2500,
// 			loanApprovalGoodForDays: 30,
// 			tiers: [
// 				{
// 					tierNum: 1,
// 					creditScoreMax: 850, // Assuming the max credit score for Tier 1 is 850
// 					creditScoreMin: 730,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1199,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1249,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 2,
// 					creditScoreMax: 729,
// 					creditScoreMin: 700,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1129,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1129,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1099,
// 							usedVehicleApr: 0.1129,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1169,
// 							usedVehicleApr: 0.1269,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1249,
// 							usedVehicleApr: 0.1349,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1329,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 3,
// 					creditScoreMax: 699,
// 					creditScoreMin: 675,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: 0.1499,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1499,
// 							usedVehicleApr: 0.1599,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1549,
// 							usedVehicleApr: 0.1649,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 4,
// 					creditScoreMax: 674,
// 					creditScoreMin: 660,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 5,
// 					creditScoreMax: 659,
// 					creditScoreMin: 0,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1899,
// 							usedVehicleApr: 0.1999,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1999,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 			],
// 			titlingAgent: TITLING_AGENT_ENUM.EKHO,
// 		},
// 		SNOWMOBILE_PWC_GOLF_SCOOTER_PROGRAM: {
// 			programKey: 'SNOWMOBILE_PWC_GOLF_SCOOTER_PROGRAM',
// 			lastUpdated: 'January 2, 2024', // Assuming the last updated date is today's date.
// 			minimumLoanAmount: 2500,
// 			loanApprovalGoodForDays: 30,
// 			tiers: [
// 				{
// 					tierNum: 1,
// 					creditScoreMax: 850, // Assuming the max credit score for Tier 1 is 850
// 					creditScoreMin: 730,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.0999,
// 							usedVehicleApr: 0.1099,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1249,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1249,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 2,
// 					creditScoreMax: 729,
// 					creditScoreMin: 700,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1179,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1179,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1149,
// 							usedVehicleApr: 0.1179,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1199,
// 							usedVehicleApr: 0.1299,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1299,
// 							usedVehicleApr: 0.1399,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1399,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 3,
// 					creditScoreMax: 699,
// 					creditScoreMin: 675,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1449,
// 							usedVehicleApr: 0.1549,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1449,
// 							usedVehicleApr: 0.1549,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1449,
// 							usedVehicleApr: 0.1549,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1549,
// 							usedVehicleApr: 0.1649,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1599,
// 							usedVehicleApr: 0.1699,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 4,
// 					creditScoreMax: 674,
// 					creditScoreMin: 660,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1649,
// 							usedVehicleApr: 0.1749,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1699,
// 							usedVehicleApr: 0.1799,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1749,
// 							usedVehicleApr: null,
// 						},
// 						84: {
// 							numMonths: 84,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 				{
// 					tierNum: 5,
// 					creditScoreMax: 659,
// 					creditScoreMin: 0,
// 					terms: {
// 						24: {
// 							numMonths: 24,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						36: {
// 							numMonths: 36,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						48: {
// 							numMonths: 48,
// 							newVehicleApr: 0.1799,
// 							usedVehicleApr: 0.1899,
// 						},
// 						60: {
// 							numMonths: 60,
// 							newVehicleApr: 0.1899,
// 							usedVehicleApr: 0.1999,
// 						},
// 						72: {
// 							numMonths: 72,
// 							newVehicleApr: 0.1999,
// 							usedVehicleApr: null,
// 						},
// 					},
// 				},
// 			],
// 			titlingAgent: TITLING_AGENT_ENUM.EKHO,
// 		},
// 	},
// };
export const EKHO_LOAN_TERM_OPTIONS = [24, 36, 48, 60, 72, 84];

export const TEMP_TAG_FEE = 20;
export const VI_PROCESSING_FEE = 165;
export const CG_PROCESSING_FEE = 30;
export const PAPERWORK_FEE = 20; // shipping of documents etc.

// Used in checkout to produce registration options, and in backend
export const TAR_PROCESS_ENUM = {
	ASSISTED: 'ASSISTED',
	AUTOMATED: 'AUTOMATED',
	ASSISTED_TITLING: 'ASSISTED_TITLING',
	AUTOMATED_TITLING: 'AUTOMATED_TITLING',
	NONE: 'NONE',
};

export const TAR_AGENT_ENUM = {
	BUYER: 'BUYER',
	EKHO: 'EKHO', // deprecated
	VI: 'VI',
	CG: 'CG',
	NONE: 'NONE',
};

export const STATE_DATA_TAR_PROCESS_KEYS = {
	automatedTARSupported: 'automatedTARSupported',
	assistedTARNotSupported: 'assistedTARNotSupported',
	automatedTitlingSupported: 'automatedTitlingSupported',
	assistedTitlingNotSupported: 'assistedTitlingNotSupported',
	noneSupported: 'noneSupported',
};

export const TAR_PROCESS_TO_STATE_PROCESS_MAP_KEY = {
	[TAR_PROCESS_ENUM.ASSISTED]: STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported,
	[TAR_PROCESS_ENUM.AUTOMATED]: STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported,
	[TAR_PROCESS_ENUM.ASSISTED_TITLING]: STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported,
	[TAR_PROCESS_ENUM.AUTOMATED_TITLING]: STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported,
	[TAR_PROCESS_ENUM.NONE]: STATE_DATA_TAR_PROCESS_KEYS.noneSupported,
};

// the enum we use on the purchasedVehicle.paymentInfo.paymentSelectionType
export const PAYMENT_SELECTION_TYPES = {
	cash: 'cash',
	cashEarly: 'cashEarly',
	nativeFinancing: 'nativeFinancing',
	otherFinancing: 'otherFinancing',
	checkoutFullPayment: 'checkoutFullPayment',
	klarnaCheckoutFullPayment: 'klarnaCheckoutFullPayment',
};

export const INSURANCE_SELECTION_TYPES = {
	skipInsurance: 'skipInsurance',
	purchaseInsurance: 'purchaseInsurance',
	useExistingInsurance: 'useExistingInsurance',
	provideBasicDetails: 'provideBasicDetails',
};

export const CG_VEHICLE_TYPE_ENUM = {
	// Keys should match our internal vehicle type enum values
	[VehicleType.ATV]: 'ATV',
	[VehicleType.ORV]: 'ORV',
	[VehicleType.LOW_SPEED]: 'LOW_SPEED',
	[VehicleType.OHV]: 'OHV',
	[VehicleType.MOTORCYCLE]: 'MOTORCYCLE',
};

export const INTERNAL_FUEL_TYPE_ENUM = {
	GASOLINE: 'Gasoline',
	DIESEL: 'Diesel',
	HYDROGEN_FUEL_CELL: 'HydrogenFuelCell',
	ELECTRIC: 'Electric',
	NATURAL_GAS_POWERED: 'NaturalGasPowered',
	FLEX_FUEL: 'FlexFuel',
	HYBRID_DIESEL_ELECTRIC: 'HybridDieselElectric',
	HYBRID_GASOLINE_ELECTRIC: 'HybridGasolineElectric',
};

export const BANK_INSURANCE_REQS = {
	[FINANCING_BANK_NAME_ENUM.FRF]: {
		[VehicleType.MOPED]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.MOTORCYCLE]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.LOW_SPEED]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.NEV]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.PASSENGER]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.COMMERCIAL]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.TRAILER]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.TRUCK]: {
			required: true,
			minimumTotalPrice: 5000,
		},
		[VehicleType.OHV]: {
			required: false,
		},
		[VehicleType.VESSEL]: {
			required: false,
		},
		[VehicleType.GO_KART]: {
			required: false,
		},
		[VehicleType.E_BIKE]: {
			required: false,
		},
		[VehicleType.ATV]: {
			required: false,
		},
		[VehicleType.ORV]: {
			required: false,
		},
		[VehicleType.DUAL_SPORT]: {
			required: false,
		},
	},
	[FINANCING_BANK_NAME_ENUM.IRONHORSE]: {
		[VehicleType.MOPED]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.MOTORCYCLE]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.LOW_SPEED]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.NEV]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.PASSENGER]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.COMMERCIAL]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.TRAILER]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.TRUCK]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.OHV]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[VehicleType.VESSEL]: {
			required: true,
			minimumTotalPrice: 0,
		},
		[VehicleType.GO_KART]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[VehicleType.E_BIKE]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[VehicleType.ATV]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[VehicleType.ORV]: {
			required: true,
			minimumTotalPrice: 15000,
		},
		[VehicleType.DUAL_SPORT]: {
			required: false,
			minimumTotalPrice: 15000,
		},
	},
} as {
	[bankName: string]: {
		[vehicleType: string]: {
			required: boolean;
			minimumTotalPrice?: number;
		};
	};
};

// used in buyer portal and other places to determine if insurance is required
export const insuranceReqTypes = {
	validationRequired: 'validationRequired',
	basicInformationRequired: 'basicInformationRequired',
	insuranceNotRequired: 'insuranceNotRequired',
};

export const OEMS_THAT_CAN_OVERRIDE_VEHICLE_IMG_URL = ['stark'];

export const ORDER_CREATION_TYPES = {
	ANTE_PREORDER: 'ANTE_PREORDER',
	ORGANIC: 'ORGANIC',
	PREORDER: 'PREORDER',
	EXISTINGORDER: 'EXISTINGORDER',
	OEMORIGINATED: 'OEMORIGINATED',
	ABANDONEDCART: 'ABANDONEDCART',
	ABANDONED_ANTE_PREORDER: 'ABANDONED_ANTE_PREORDER',
	DEALER_LEAD: 'DEALER_LEAD',
};

export const LEAD_TYPE_ENUM = {
	IN_PERSON_PURCHASE: 'IN_PERSON_PURCHASE',
};

export const HOW_IT_WORKS_SECTIONS_ENUM = {
	PREORDER: 'PREORDER',
	PREORDER_CONVERSION: 'PREORDER_CONVERSION',
	ORDER: 'ORDER',
	FINANCING: 'FINANCING',
	INSURANCE: 'INSURANCE',
	TAR_PROCESS_AUTOMATED: 'TAR_PROCESS_AUTOMATED',
	TAR_PROCESS_ASSISTED: 'TAR_PROCESS_ASSISTED',
	TAR_PROCESS_AUTOMATED_TITLING: 'TAR_PROCESS_AUTOMATED_TITLING',
	TAR_PROCESS_ASSISTED_TITLING: 'TAR_PROCESS_ASSISTED_TITLING',
	PAPERWORK: 'PAPERWORK',
	HOME_DELIVERY: 'HOME_DELIVERY',
	PICK_UP: 'PICK_UP',
};

export const HOW_IT_WORKS_SECTIONS = {
	[HOW_IT_WORKS_SECTIONS_ENUM.PREORDER]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PREORDER,
		order: 0,
		activeStep: true,
		// or false depending on the context or data
		completed: false,
		// Assuming this step has not been completed yet
		optional: false,
		iconName: 'LockClock',
		title: 'Secure your build slot',
		description: `Place a deposit to secure your vehicle build slot. You'll receive an email once you've placed your preorder.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.PREORDER_CONVERSION]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PREORDER_CONVERSION,
		order: 1,
		activeStep: false,
		// or false depending on the context or data
		completed: false,
		// Assuming this step has not been completed yet
		optional: false,
		iconName: 'ShoppingCart',
		title: 'Finalize your order',
		description: `Select your remaining payment, delivery, and registration choices to finalize your order. You'll be invited to complete this step once your preorder has been prioritized.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.ORDER]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.ORDER,
		order: 1,
		activeStep: true, // or false depending on the context or data
		completed: false, // Assuming this step has not been completed yet
		optional: false,
		iconName: 'ShoppingCart',
		title: 'Provide basic order and contact info',
		description: `Make your payment, delivery, and registration choices here on this Ekho Checkout page. You'll receive an email once you've placed your order.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.FINANCING]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.FINANCING,
		order: 2,
		activeStep: false,
		completed: false,
		optional: true,
		iconName: 'AccountBalance',
		title: 'Apply for financing',
		description: `If you're financing your purchase, you'll also complete a short financing application in the Ekho Checkout page! We'll let you know if you're approved within minutes.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.INSURANCE]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.INSURANCE,
		order: 3,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'Security',
		title: 'Protect your vehicle',
		description: `If necessary, purchase new or validate existing insurance from within Ekho's platform.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED,
		order: 4,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Automated registration',
		description: `Let Ekho handle the registration process for you (no trip to the DMV).`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED,
		order: 5,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Assisted registration',
		description: `Let Ekho help you complete the state registration process.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED_TITLING]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_AUTOMATED_TITLING,
		order: 5,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Automated titling',
		description: `Let Ekho handle the titling process for you (no trip to the DMV).`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED_TITLING]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.TAR_PROCESS_ASSISTED_TITLING,
		order: 6,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'VerifiedUser',
		title: 'Assisted titling',
		description: `Let Ekho help you complete the state titling process.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.PAPERWORK]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PAPERWORK,
		order: 7,
		activeStep: false,
		completed: false,
		iconName: 'Task',
		optional: false,
		title: 'Complete your paperwork',
		description: `Sign your sales contracts and any other necessary state documents. We'll provide instructions that'll make this part easy.`,
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.HOME_DELIVERY]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.HOME_DELIVERY,
		order: 8,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'BikeScooter',
		title: 'Take delivery',
		description: 'Take delivery of your vehicle at your specified delivery location.',
	},
	[HOW_IT_WORKS_SECTIONS_ENUM.PICK_UP]: {
		id: HOW_IT_WORKS_SECTIONS_ENUM.PICK_UP,
		order: 9,
		activeStep: false,
		completed: false,
		optional: false,
		iconName: 'BikeScooter',
		title: 'Pick up your vehicle',
		description: 'Pick up your vehicle from your chosen pickup location.',
	},
};

export const EKHO_APPS_ENUM = {
	BUYER_PORTAL: 'BUYER_PORTAL',
	DEALER_PORTAL: 'DEALER_PORTAL',
	ADMIN_PORTAL: 'ADMIN_PORTAL',
	CHECKOUT: 'CHECKOUT',
	INFO_MODAL: 'INFO_MODAL',
};

export const SUPPORT_TOPICS = {
	PAYMENT: {
		key: 'PAYMENT',
		title: 'Payment & financing',
		description: 'Questions about payment options, financing, terms, etc.',
		commsOwnedByEkho: true,
	},
	VEHICLE: {
		key: 'VEHICLE',
		title: 'Vehicle details',
		description:
			"Questions about the vehicle you're purchasing, it's specs, condition, configuration, etc.",
		commsOwnedByEkho: false,
	},
	INSURANCE: {
		key: 'INSURANCE',
		title: 'Insurance',
		description: 'Questions about insurance, state requirements, your options, etc.',
		commsOwnedByEkho: true,
	},
	REGISTRATION: {
		key: 'REGISTRATION',
		title: 'Registration & titling',
		description:
			"Questions about registration, titling, the process, what's required, street legal vs off-road, etc.",
		commsOwnedByEkho: true,
	},
	DELIVERY: {
		key: 'DELIVERY',
		title: 'Delivery',
		description: 'Questions about the delivery process, timing, etc.',
		commsOwnedByEkho: false,
	},
	PICK_UP: {
		key: 'PICK_UP',
		title: 'Pick up',
		description: 'Questions about the pick up process, timing, etc.',
		commsOwnedByEkho: false,
	},
	TECHNICAL: {
		key: 'TECHNICAL',
		title: 'Technical issues',
		description: 'Questions about the checkout process, errors, bugs, etc.',
		commsOwnedByEkho: true,
	},
	OTHER: {
		key: 'OTHER',
		title: 'Other',
		description: 'Questions about Ekho, our services, or anything else.',
		commsOwnedByEkho: true,
	},
};

// Defines when we do web vs mobile rendering in BP and Checkout
export const STACKING_BREAKPOINT = 1150; // in px
export const CHECKOUT_INFO_MAX_WIDTH = 650; // in px
export const WEB_INNER_SIDE_PADDING = 5; // in rem
export const WEB_OUTER_SIDE_PADDING = 2; // in rem
export const WEB_VERTICAL_PADDING = 3; // in rem
export const MOBILE_SIDE_PADDING = 2; // in rem

export const EKHO_PHONE_SUPPORT_SCHEDULE = {
	monday: {
		start: '08:30',
		end: '19:00',
		day: 'monday',
	},
	tuesday: {
		start: '08:30',
		end: '19:00',
		day: 'tuesday',
	},
	wednesday: {
		start: '08:30',
		end: '19:00',
		day: 'wednesday',
	},
	thursday: {
		start: '08:30',
		end: '19:00',
		day: 'thursday',
	},
	friday: {
		start: '08:30',
		end: '19:00',
		day: 'friday',
	},
};

export const SUPPORT_MODAL_STATE = {
	SUPPORT_HUB: 'SUPPPORT_HUB',
	MESSAGE_OEM: 'MESSAGE_OEM',
	MESSAGE_SENT: 'MESSAGE_SENT',
};

export const PICK_UP_LOCATION_TYPE_ENUM = {
	DEALER: 'DEALER',
	EKHO: 'EKHO',
	OEM: 'OEM',
};

export const FEE_ESTIMATE_FIDELITIES = {
	FINAL: 'final',
	INITIAL: 'initial',
	API_ESTIMATE: 'apiEstimate',
	ACTUAL: 'actual',
};

export const GOOGLE_MAP_STYLES = [
	// {
	// 	featureType: 'all',
	// 	elementType: 'labels',
	// 	stylers: [{ visibility: 'off' }],
	// },
	{
		featureType: 'all',
		elementType: 'labels.icon',
		stylers: [{ visibility: 'off' }],
	},
	// {
	// 	featureType: 'road',
	// 	elementType: 'geometry',
	// 	stylers: [{ visibility: 'simplified' }],
	// },
	// {
	// 	featureType: 'road.arterial',
	// 	elementType: 'labels',
	// 	stylers: [{ visibility: 'off' }],
	// },
	{
		featureType: 'poi',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }],
	},
	// {
	// 	featureType: 'water',
	// 	elementType: 'labels',
	// 	stylers: [{ visibility: 'off' }],
	// },
	{
		featureType: 'transit',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }],
	},
];

export const FORMIK_DATE_FIELDS = [
	'dob',
	'dlExpDate',
	'homeMoveInDate',
	'jobStartDate',
	'effectiveDate',
	'expiryDate',
];

// FINANCING APPLICATION CONSTANTS
export const EKHO_FINANCING_APPLICATION_CONSTANTS = {
	MARITAL_STATUS_OPTIONS: {
		SINGLE: 'Single',
		MARRIED: 'Married',
		WIDOWED: 'Widowed',
		DIVORCED: 'Divorced',
		SEPARATED: 'Separated',
	},
	HOUSING_OWNERSHIP_OPTIONS: {
		OWNED: 'Owned',
		RENTED: 'Rented',
		FAMILY: 'Family',
		LIVES_WITH_RELATIVES: 'LivesWithRelatives',
	},
	EMPLOYMENT_STATUS_OPTIONS: {
		EMPLOYED: 'Employed',
		SELF_EMPLOYED: 'SelfEmployed',
		RETIRED: 'Retired',
	},
	INCOME_TYPE_OPTIONS: {
		SPOUSAL_INCOME: 'SpousalIncome',
		CHILD_SUPPORT: 'childSupport',
		DISABILITY: 'disability',
		INVESTMENT: 'investment',
		PENSION: 'pension',
		RENTAL: 'rental',
		RETIREMENT_INCOME: 'retirementIncome',
		SOCIAL_SECURITY: 'socialSecurity',
		ALIMONY: 'alimony',
		UNEMPLOYMENT: 'unemployment',
		OTHER: 'other',
	},
	INCOME_TYPE_DESCRIPTIONS: {
		SPOUSAL_INCOME: 'The income that your partner earns.',
		CHILD_SUPPORT: 'The income that you receive from child support payments.',
		DISABILITY: 'The income that you receive from disability payments.',
		INVESTMENT:
			'The income that you receive from investments (e.g. dividends, interest, etc.).',
		PENSION: 'The income that you receive from a pension.',
		RENTAL: 'The income that you receive from rental properties.',
		RETIREMENT_INCOME: 'The income that you receive from retirement accounts.',
		SOCIAL_SECURITY: 'The income that you receive from social security payments.',
		ALIMONY: 'The income that you receive from alimony payments.',
		UNEMPLOYMENT: 'The income that you receive from unemployment benefits.',
		OTHER: 'Any other income that you receive that is not listed above.',
		VERIFY_IDENTITY: 'Please have the Applicant Call Freedom Road to Verify Identity',
	},
	REFERENCE_RELATIONSHIP_OPTIONS: {
		EMPLOYER: 'Employer',
		FRIEND: 'Friend',
		OTHER: 'Other',
		PARENT: 'Parent',
		RELATIVE: 'Relative',
		SPOUSE: 'Spouse',
	},
};

export const EKHO_FINANCING_STIPULATIONS_KEYS = {
	CALL_FRF_TO_VERIFY_IDENTITY_STIP: 'CALL_FRF_TO_VERIFY_IDENTITY_STIP',
	PAYOFF_OUTSTANDING_LOAN_STIP: 'PAYOFF_OUTSTANDING_LOAN_STIP',
	NOTARIZED_CONTRACT_STIP: 'NOTARIZED_CONTRACT_STIP',
	PERSONAL_REFERENCES_STIP: 'PERSONAL_REFERENCES_STIP',
	PROOF_OF_INCOME_STIP: 'PROOF_OF_INCOME_STIP',
	ADDITIONAL_INCOME_STIP: 'ADDITIONAL_INCOME_STIP',
	PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP: 'PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP',
	FIVE_PERSONAL_REFERENCES_STIP: 'FIVE_PERSONAL_REFERENCES_STIP',
	MAX_FINANCED_STIP: 'MAX_FINANCED_STIP',
	PROOF_OF_RESIDENCE_STIP: 'PROOF_OF_RESIDENCE_STIP',
	PROOF_OF_SSN_STIP: 'PROOF_OF_SSN_STIP',
	PROOF_OF_EMPLOYMENT_STIP: 'PROOF_OF_EMPLOYMENT_STIP',
	DOWN_PAYMENT_STIP: 'DOWN_PAYMENT_STIP',
	VALID_DRIVERS_LICENSE_STIP: 'VALID_DRIVERS_LICENSE_STIP',
	FIRST_TIME_BUYER_STIP: 'FIRST_TIME_BUYER_STIP',
	FULL_INSURANCE_COVERAGE_REQUIRED_STIP: 'FULL_INSURANCE_COVERAGE_REQUIRED_STIP',
	ITEMIZED_ACCESSORY_LIST_STIP: 'ITEMIZED_ACCESSORY_LIST_STIP',
};

export const FRF_STIP_TO_EKHO_STIP_MAPPING = {
	'out of state applicant contract to be notarized': [
		EKHO_FINANCING_STIPULATIONS_KEYS.NOTARIZED_CONTRACT_STIP,
	],
	'please provide 2 personal references': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
	],
	'this application is max financed': [EKHO_FINANCING_STIPULATIONS_KEYS.MAX_FINANCED_STIP],
	'proof of residence': [EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP],
	'proof of income': [EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP],
	'please provide additional income consumers debt to income ratio too high': [
		EKHO_FINANCING_STIPULATIONS_KEYS.ADDITIONAL_INCOME_STIP,
	],
	'please provide additional income consumers payment to income ratio too high': [
		EKHO_FINANCING_STIPULATIONS_KEYS.ADDITIONAL_INCOME_STIP,
	],
	'please provide proof of additional income': [
		EKHO_FINANCING_STIPULATIONS_KEYS.ADDITIONAL_INCOME_STIP,
	],
	'please have the applicant call freedom road to verify identity': [
		EKHO_FINANCING_STIPULATIONS_KEYS.CALL_FRF_TO_VERIFY_IDENTITY_STIP,
	],
	'please have the applicant call underwriting to verify identity': [
		EKHO_FINANCING_STIPULATIONS_KEYS.CALL_FRF_TO_VERIFY_IDENTITY_STIP,
	],
	'please provide current work phone number': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROVIDE_CURRENT_WORK_PHONE_NUMBER_STIP,
	],
	'must have full down payment': [EKHO_FINANCING_STIPULATIONS_KEYS.DOWN_PAYMENT_STIP],
	'first time buyer': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.FIRST_TIME_BUYER_STIP,
	],
	'first time buyer program -  need poi, por and 2 references': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.FIRST_TIME_BUYER_STIP,
	],
	'proof of employment': [EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_EMPLOYMENT_STIP],
	'ftb program need poi por and 2 references': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP,
		EKHO_FINANCING_STIPULATIONS_KEYS.FIRST_TIME_BUYER_STIP,
	],
	'must payoff existing freedom road loan': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PAYOFF_OUTSTANDING_LOAN_STIP,
	],
	'must payoff existing performance finance loan': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PAYOFF_OUTSTANDING_LOAN_STIP,
	],
	'please provide a copy of a valid drivers license prior to approval': [
		EKHO_FINANCING_STIPULATIONS_KEYS.VALID_DRIVERS_LICENSE_STIP,
	],
	'please provide a copy of the applicant ssn card': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_SSN_STIP,
	],
	'full insurance coverage required': [
		EKHO_FINANCING_STIPULATIONS_KEYS.FULL_INSURANCE_COVERAGE_REQUIRED_STIP,
	],
	'itemized accessory list': [EKHO_FINANCING_STIPULATIONS_KEYS.ITEMIZED_ACCESSORY_LIST_STIP],
};

export const IRONHORSE_STIP_TO_EKHO_STIP_MAPPING = {
	'new insurance binder loss payee address see approval ltr': [], // IGNORE THIS STIP, map to empty array
	'new lienholder address for title & ucc see approval ltr': [], // IGNORE THIS STIP, map to empty array
	'bill of sale': [], // IGNORE THIS STIP, map to empty array
	'open hd tied to trade in to be paid off': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PAYOFF_OUTSTANDING_LOAN_STIP,
	],
	'proof of income applicant pay stub with ytd income': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
	'proof of income coapplicant pay stub with ytd income': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
	'5 references': [EKHO_FINANCING_STIPULATIONS_KEYS.FIVE_PERSONAL_REFERENCES_STIP],
	'2 references': [EKHO_FINANCING_STIPULATIONS_KEYS.PERSONAL_REFERENCES_STIP],
	'drivers license applicant': [EKHO_FINANCING_STIPULATIONS_KEYS.VALID_DRIVERS_LICENSE_STIP],
	'drivers license coapplicant': [EKHO_FINANCING_STIPULATIONS_KEYS.VALID_DRIVERS_LICENSE_STIP],
	'proof of residence address applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
	],
	'proof of residence address co applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_RESIDENCE_STIP,
	],
	'clear credit bureau alert': [], // IGNORE THIS STIP, map to empty array
	'ss card or irs documentation to confirm ssn applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_SSN_STIP,
	],
	'proof of income prior year ytd paystub or w2 applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
	'proof of income prior year ytd paystub or w2 co applicant': [
		EKHO_FINANCING_STIPULATIONS_KEYS.PROOF_OF_INCOME_STIP,
	],
};

export const CREDIT_APP_DISCLAIMER = `By clicking the button below, I agree to have my credit application submitted to Ekho Inc. and its subsidiaries (collectively "Ekho").  I authorize Ekho, its affiliates, and any bank or lender, or other institution (collectively "Creditor") to whom my application is submitted to investigate my credit and employment history, verify my employment and income, obtain credit reports, and to the extent permitted by law, release information about my credit experience now or in the future. I acknowledge and agree that each Creditor may monitor and record telephone calls regarding my account for quality assurance or other similar purposes. Each Creditor may contact me by written, electronic or verbal means, to the extent permitted by law. I expressly agree to being contacted by prerecorded or artificial voice messages, text messages, emails and/or automatic telephone dialing systems at any e-mail address or any telephone number I provide, now or in the future, including a number for a mobile device, regardless of whether I incur charges as a result. NOTE that, if your vehicle isn't shipped within 30 days of your application date, we must re-submit it for lender re-approval, which may change terms and trigger a second hard credit inquiry.`;

/* FINANCING DEFAULT CONSTS */
export const INITIAL_TERM = 84;
export const INITIAL_DOWN_PAYMENT_SUBTRACTION = 1500;
export const DEFAULT_MIN_LOAN_AMOUNT = 2500;

export const EKHO_FINANCING_APPLICATION_SECTIONS = {
	PREFERRED_TERMS: 'Preferred terms',
	PERSONAL_DETAILS: 'Personal details',
	EMPLOYMENT_INFO: 'Employment information',
	OTHER_SOURCES_OF_INCOME: 'Other sources of income',
	ADDITIONAL_INFO: 'Additional information',
};

export const EKHO_FINANCING_APPLICATION_CATEGORIZATIONS = {
	[EKHO_FINANCING_APPLICATION_SECTIONS.PREFERRED_TERMS]: [
		CREDIT_APP_FIELD_IDS.LOAN_TERM,
		CREDIT_APP_FIELD_IDS.DOWN_PAYMENT_AMT,
	],
	[EKHO_FINANCING_APPLICATION_SECTIONS.PERSONAL_DETAILS]: [
		CREDIT_APP_FIELD_IDS.DOB,
		CREDIT_APP_FIELD_IDS.PHONE_NUMBER,
		CREDIT_APP_FIELD_IDS.SSN,
		CREDIT_APP_FIELD_IDS.MARITAL_STATUS,
		CREDIT_APP_FIELD_IDS.HOME_ADDRESS_SAME_AS_ID_ADDRESS,
		CREDIT_APP_FIELD_IDS.HOUSING_OWNERSHIP,
		CREDIT_APP_FIELD_IDS.HOME_MOVE_IN_DATE,
		CREDIT_APP_FIELD_IDS.MONTHLY_AMT,
		'addressString',
		'addressLineOne',
		'addressLineTwo',
		'city',
		'county',
		'state',
		'zip',
	],
	[EKHO_FINANCING_APPLICATION_SECTIONS.EMPLOYMENT_INFO]: [
		CREDIT_APP_FIELD_IDS.EMPLOYMENT_STATUS,
		CREDIT_APP_FIELD_IDS.MONTHLY_GROSS_INCOME,
		CREDIT_APP_FIELD_IDS.EMPLOYER_NAME,
		CREDIT_APP_FIELD_IDS.EMPLOYER_PHONE_NUMBER,
		CREDIT_APP_FIELD_IDS.OCCUPATION,
		CREDIT_APP_FIELD_IDS.JOB_START_DATE,
		'addressString',
		'addressLineOne',
		'addressLineTwo',
		'city',
		'county',
		'state',
		'zip',
	],
	[EKHO_FINANCING_APPLICATION_SECTIONS.OTHER_SOURCES_OF_INCOME]: ['otherIncomes'],
	[EKHO_FINANCING_APPLICATION_SECTIONS.ADDITIONAL_INFO]: [CREDIT_APP_FIELD_IDS.NOTE_TO_LENDER],
};

// Hotjar map
export const OEM_KEY_TO_HOTJAR_SITE_ID = {
	BUYER_PORTAL: {
		janus: 3720403,
		moke: 3720410,
		e2etestoem: 3715982,
	},
	CHECKOUT: {
		stark: 5101827,
	},
};

// Stripe payment status enum
export const PAYMENT_STATUS_ENUM = {
	PROCESSING: 'processing',
	SUCCEEDED: 'succeeded',
	REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
	REQUIRES_ACTION: 'requires_action',
	CANCELED: 'canceled',
	REQUIRES_CONFIRMATION: 'requires_confirmation',
	REQUIRES_CAPTURE: 'requires_capture',
};

export const CANCELATION_AGENT_ENUM = {
	BUYER_CANCELED: 'BUYER_CANCELED',
	EKHO_CANCELED: 'EKHO_CANCELED',
};

export const LENDER_DECISION_OPTIONS = {
	accepted: 'accepted',
	rejected: 'rejected',
	needMoreInfo: 'needMoreInfo',
	counterOffer: 'counterOffer',
};

// The different types of decisions a buyer can make on a finance offer from the lender. This will grow with time.
export const financeOfferBuyerDecisionTypes = {
	accepted: 'accepted',
	declined: 'declined',
};

export const RELOCATION_FLOWS = {
	SELECT_DELIVERY_PREF: 'SELECT_DELIVERY_PREF',
	SEE_FINANCING_DECISIONS: 'SEE_FINANCING_DECISIONS',
	RETRY_INSURANCE_VALIDATION: 'RETRY_INSURANCE_VALIDATION',
	FAILED_ACH_PAYMENT: 'FAILED_ACH_PAYMENT',
	SIGN_RIC: 'SIGN_RIC',
	FINANCING_STIPULATIONS: 'FINANCING_STIPULATIONS',
	SIGN_FINANCING_DOCS: 'SIGN_FINANCING_DOCS',
	ROBOTIC_SIGNING_START_SIGNING: 'ROBOTIC_SIGNING_START_SIGNING',
	ROBOTIC_SIGNING_APPROVED: 'ROBOTIC_SIGNING_APPROVED',
	ROBOTIC_SIGNING_MISSED_SESSION: 'ROBOTIC_SIGNING_MISSED_SESSION',
	ROBOTIC_SIGNING_CANCEL_SIGNING: 'ROBOTIC_SIGNING_CANCEL_SIGNING',
	ROBOTIC_SIGNING_RESCHEDULE_SIGNING: 'ROBOTIC_SIGNING_RESCHEDULE_SIGNING',
	ROBOTIC_SIGNING_REDO_SIGNING: 'ROBOTIC_SIGNING_REDO_SIGNING',
	// Add other relocation flows here...
	// Note: must also add to buyer portal
};

export const FULFILLMENT_STATUS_ENUM = {
	UNFULFILLED: 'UNFULFILLED',
	ON_HOLD: 'ON_HOLD',
	CANCELED: 'CANCELED',
	READY_TO_FULFILL: 'READY_TO_FULFILL',
	READY_TO_DISPATCH: 'READY_TO_DISPATCH',
	FULFILLED: 'FULFILLED',
	IN_TRANSIT_TO_BUYER: 'IN_TRANSIT_TO_BUYER',
	IN_TRANSIT_TO_FULFILLMENT_CENTER: 'IN_TRANSIT_TO_FULFILLMENT_CENTER',
	PICKUP_SCHEDULED: 'PICKUP_SCHEDULED',
	DELIVERY_FULFILLMENT_IN_PROGRESS: 'DELIVERY_FULFILLMENT_IN_PROGRESS',
	RECEIVED_AT_FULFILLMENT_CENTER: 'RECEIVED_AT_FULFILLMENT_CENTER',
};

export const RELOC_MODAL_NAMES = {
	FAILED_ACH_MODAL: 'failedACHPaymentModal',
	SIGN_RIC_MODAL: 'signRICModal',
	SIGN_FINANCING_DOCS_MODAL: 'signFinancingDocsModal',
	SURVEY_MODAL: 'surveyModal',
	FINANCING_STIPULATIONS_MODAL: 'financingStipulationsModal',
	FAILED_KLARNA_PAYMENT_MODAL: 'failedKlarnaPaymentModal',
	RETRY_INSURANCE_VALIDATION_MODAL: 'retryInsuranceValidationModal',
	SEE_FINANCING_DECISIONS_MODAL: 'seeFinancingDecisionsModal',
	FINALIZE_FINANCING_SELECTION_MODAL: 'finalizeFinancingSelectionModal',
	ROBOTIC_SIGNING_START_SIGNING: 'roboticSigningStartSigningModal',
	ROBOTIC_SIGNING_APPROVED: 'roboticSigningApprovedModal',
	ROBOTIC_SIGNING_MISSED_SESSION: 'roboticSigningMissedSessionModal',
	ROBOTIC_SIGNING_CANCEL_SIGNING: 'roboticSigningCancelSigningModal',
	ROBOTIC_SIGNING_RESCHEDULE_SIGNING: 'roboticSigningRescheduleSigningModal',
	ROBOTIC_SIGNING_REDO_SIGNING: 'roboticSigningRedoSigningModal',
};

export const AllModalPageNames = {
	loadingPage: 'loadingPage',
	getStartedPage: 'getStartedPage',
	// beginVerificationPage: 'beginVerificationPage',
	// verificationInProgressPage: 'verificationInProgressPage',
	// verificationSucceededPage: 'verificationSucceededPage',
	// verificationRetryPage: 'verificationRetryPage',
	signOffPage: 'signOffPage',
	somethingWrongPage: 'somethingWrongPage',
	deliverySelectionPage: 'deliverySelectionPage',
	registrationAddressSelectionPage: 'registrationAddressSelectionPage',
	verificationMaxAttemptsPage: 'verificationMaxAttemptsPage',
	selectDeliveryPrefPage: 'selectDeliveryPrefPage',
	simpleAlertModal: 'simpleAlertModal',
	ekhoMustTARAlertModal: 'ekhoMustTARAlertModal',
	orderCancellationModal: 'orderCancellationModal',
	seeFinancingDecisionsModal: 'seeFinancingDecisionsModal',
	retryInsuranceValidationModal: 'retryInsuranceValidationModal',
	failedACHPaymentModal: 'failedACHPaymentModal',
	signRICModal: 'signRICModal',
	surveyModal: 'surveyModal',
	financingStipulationsModal: 'financingStipulationsModal',
	roboticSigningStartSigningModal: 'roboticSigningStartSigningModal',
	roboticSigningApprovedModal: 'roboticSigningApprovedModal',
	roboticSigningMissedSessionModal: 'roboticSigningMissedSessionModal',
	roboticSigningCancelSigningModal: 'roboticSigningCancelSigningModal',
	roboticSigningRescheduleSigningModal: 'roboticSigningRescheduleSigningModal',
	roboticSigningRedoSigningModal: 'roboticSigningRedoSigningModal',
	failedKlarnaPaymentModal: 'failedKlarnaPaymentModal',
	authSessionExpiredModal: 'authSessionExpiredModal',
	confirmDeclineFinancingModal: 'confirmDeclineFinancingModal',
	signFinancingDocsModal: 'signFinancingDocsModal',
};

export const EKHO_SERVICES_PROVIDER_ID = 'svp_ekho';

export const ROBOTIC_SIGNING_STATUS = {
	scheduled: 'scheduled',
	in_session: 'in_session',
	self_review: 'self_review',
	under_review: 'under_review',
	approved: 'approved',
};

export const NO_VIN_NEEDED_VEHICLE_TYPES = [VehicleType.E_BIKE, VehicleType.BICYCLE];
export const NO_ODOMETER_VEHICLE_TYPES = [
	VehicleType.E_BIKE,
	VehicleType.BICYCLE,
	VehicleType.GO_KART, // there may be some go karts that have odometers but we do not sell any right now
];

export const PAYMENT_CHOICES = {
	[PAYMENT_TYPES.CHECKOUT_FULL_PAYMENT]: PAYMENT_TYPES.CHECKOUT_FULL_PAYMENT,
	[PAYMENT_TYPES.LOAN_DOWNPAYMENT]: PAYMENT_TYPES.LOAN_DOWNPAYMENT, // Value when financing is selected (even if zero downpayment)
	[PAYMENT_TYPES.STANDARD_RESERVATION]: PAYMENT_TYPES.STANDARD_RESERVATION,
	[PAYMENT_TYPES.PREORDER_RESERVATION]: PAYMENT_TYPES.PREORDER_RESERVATION,
	[PAYMENT_TYPES.PREORDER_VIP_RESERVATION]: PAYMENT_TYPES.PREORDER_VIP_RESERVATION,
	[PAYMENT_TYPES.KLARNA_CHECKOUT_FULL_PAYMENT]: PAYMENT_TYPES.KLARNA_CHECKOUT_FULL_PAYMENT,
	[PAYMENT_TYPES.IN_PERSON_PAYMENT]: PAYMENT_TYPES.IN_PERSON_PAYMENT,
};

export const LINE_ITEM_CATEGORIES = {
	VEHICLES: 'vehicles',
	LOOSE_ACCESSORIES: 'looseAccessories',
};

export const LINE_ITEM_CODES = {
	MSRP: 'MSRP',
	ACCESSORY: 'ACCESSORY',
	SPEC: 'SPEC',
	BOLT_ON_ACCESSORY: 'BOLT_ON_ACCESSORY',
	LOOSE_ACCESSORY: 'LOOSE_ACCESSORY',
	SHIPPING_FEE: 'SHIPPING_FEE',
	PICKUP_FEE: 'PICKUP_FEE',
	VEHICLE_ORDER_FEE: 'VEHICLE_ORDER_FEE',
	VIP_RESERVATION_FEE: 'VIP_RESERVATION_FEE',
	TEMP_TAG_FEE: 'TEMP_TAG_FEE',
	LOOSE_ACCESSORY_TAX: 'LOOSE_ACCESSORY_TAX',
	VEHICLE_SALES_TAX: 'VEHICLE_SALES_TAX',
	REGISTRATION_FEE: 'REGISTRATION_FEE',
	DISCOUNT: 'DISCOUNT',
	FULL_PAYMENT_DISCOUNT: 'FULL_PAYMENT_DISCOUNT',
	KLARNA_DISCOUNT: 'KLARNA_DISCOUNT',
	FINANCING_DOWNPAYMENT: 'FINANCING_DOWNPAYMENT',
	PREV_PAID: 'PREV_PAID',
	STATE_TAX: 'STATE_TAX',
	STATE_FEE: 'STATE_FEE',
	VENDOR_FEE: 'VENDOR_FEE',
};

export const SARDINE_SESSION_KEY = 'sardineSession';

export const PAYOUT_STATUS_TYPE = {
	CREATED: 'CREATED',
	PROMISED: 'PROMISED',
	PENDING: 'PENDING',
	SENT: 'SENT',
	PAID: 'PAID',
	HIDDEN: 'HIDDEN',
	REFUNDED: 'REFUNDED',
};

export const PAYOUT_SOURCE_TYPE = {
	BUYER: 'BUYER',
	MSRP: 'MSRP',
};

export const DOCUMENT_TRACKING_STATUS = {
	CREATED: 'CREATED',
	IN_TRANSIT: 'IN_TRANSIT',
	DELIVERED: 'DELIVERED',
	EXCEPTION: 'EXCEPTION',
};
